// ========== QUIZ ENGINE ==========
(function () {

const DEFAULT_SELLING_PLAN_ID = null; // set to null if you don't use subscriptions

const TREATMENT_PRODUCTS = {
  mounjaro: {
    id: 'mounjaro',
    nameHtml: 'Mounjaro<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_2_5mg_weight_loss_injection_png.png?v=1768558987',
    modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/cheap_Mounjaro_weight_loss_injection.png?v=1769091242',

    // display only (real price comes from selected strength below)
    price: '£195/month',
    doseCopy: '1x pen every 28 days. Pause or cancel anytime.',

    tags: [
      { variant: 'primary', label: 'Most effective' },
      { variant: 'secondary', label: 'In stock' }
    ],
    status: 'in_stock',

    startingStrengthId: 'mounjaro-2-5',

    strengths: [
      {
        id: 'mounjaro-2-5',
        label: '2.5 mg – £129',
        isStarting: true,
        variantId: 55196900524366,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£129/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/1_fc97f25a-1e27-44a4-a901-b8a659644468.png?v=1777293793'
      },
      {
        id: 'mounjaro-5',
        label: '5 mg – £179',
        isStarting: false,
        variantId: 55196900950350,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£179/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/2_87470d32-667a-4aa4-9195-adaad7a43b10.png?v=1777293793'
      },
      {
        id: 'mounjaro-7-5',
        label: '7.5 mg – £229',
        isStarting: false,
        variantId: 55196901212494,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£229/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/3_1b278af8-c748-4899-b589-fcf75464c238.png?v=1777293793'
      },
      {
        id: 'mounjaro-10',
        label: '10 mg – £249',
        isStarting: false,
        variantId: 55196901343566, // you also provided another 10mg id; confirm which is correct
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£249/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/4_0734e2b9-8e1e-43e0-bffd-37694c56e3ba.png?v=1777293793'
      },
      {
        id: 'mounjaro-12-5',
        label: '12.5 mg – £269',
        isStarting: false,
        variantId: 59122502173006, // WARNING: you didn't explicitly list 12.5mg; confirm this ID
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£269/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/5_41d56c2e-a65d-4b13-9841-0dd0e6c6fe08.png?v=1777293793'
      },
      {
        id: 'mounjaro-15',
        label: '15 mg – £279',
        isStarting: false,
        variantId: 55196901900622,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£279/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/6_25889d09-8fad-4801-91c9-07d35dff550c.png?v=1777293793'
      }
    ],

    accordions: [
      { title: 'How it works', content: 'Mounjaro works by mimicking hormones that target areas of the brain involved in regulating appetite and food intake.' },
      { title: 'Dose schedule', content: 'Taken once weekly via injection.' },
      { title: 'How to take', content: 'Inject under the skin (subcutaneously) in your stomach, thigh, or upper arm.' },
      { title: 'Potential common side effects', content: 'Nausea, diarrhoea, constipation, stomach (abdominal) pain.' },
      { title: 'Important safety information', content: 'Do not use if you have a personal or family history of Medullary Thyroid Carcinoma (MTC).' }
    ]
  },

  wegovy: {
    id: 'wegovy',
    nameHtml: 'Wegovy<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/0.25_b0e4ff93-0e3a-46e7-a61c-612270c0fe38.png?v=1772260045',
    modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/cheap_Wegovy_weight_loss_injection.png?v=1769091227',

    price: '£129/month',
    doseCopy: '1x pen every 28 days. Pause or cancel anytime.',

    tags: [
      { variant: 'primary', label: 'Cost effective' },
      { variant: 'secondary', label: 'In stock' }
    ],
    status: 'in_stock',

    startingStrengthId: 'wegovy-0-25',

    strengths: [
      {
        id: 'wegovy-0-25',
        label: '0.25 mg – £79',
        isStarting: true,
        variantId: 55196902981966,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£79/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/0.25_0823d5d0-e03d-40f0-896d-4ea78f276a6f.png?v=1772367410'
      },
      {
        id: 'wegovy-0-5',
        label: '0.5 mg – £129',
        isStarting: false,
        variantId: 55196992176462,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£129/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/8_6b0325f9-ec48-4b35-829e-5bec84907548.png?v=1777293793'
      },
      {
        id: 'wegovy-1-0',
        label: '1.0 mg – £149',
        isStarting: false,
        variantId: 55196903735630,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£149/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/9_f75edd89-66d0-4fc3-b91a-1194dbbbfb9a.png?v=1777293794'
      },
      {
        id: 'wegovy-1-7',
        label: '1.7 mg – £199',
        isStarting: false,
        variantId: 55196903965006,
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£199/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/10_915040da-0c44-4361-8764-06177a7a918b.png?v=1777293793'
      },
      {
        id: 'wegovy-2-4',
        label: '2.4 mg – £219',
        isStarting: false,
        variantId: 55196992274766, 
        sellingPlanId: DEFAULT_SELLING_PLAN_ID,
        priceText: '£219/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/11_0ddd67f9-f7f4-4db9-8860-c86a3993b79c.png?v=1777293793'
      }
    ],

    accordions: [
      { title: 'How it works', content: 'Wegovy works by mimicking a single hormone that targets areas of the brain that regulate appetite and food intake.' },
      { title: 'Dose schedule', content: 'Taken once weekly via injection.' },
      { title: 'How to take', content: 'Inject under the skin (subcutaneously) in your stomach, thigh, or upper arm.' },
      { title: 'Potential common side effects', content: 'Nausea, diarrhoea, constipation, stomach (abdominal) pain.' },
      { title: 'Important safety information', content: 'Do not use if you have a personal or family history of Medullary Thyroid Carcinoma (MTC).' }
    ]
  },

  orlos: {
    id: 'orlos',
    nameHtml: 'Orlos<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/orlos_cfa1d1e4-34ea-43b2-9d6a-ff19ce47d32f.png?v=1772346852',
    modalImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/orlos_cfa1d1e4-34ea-43b2-9d6a-ff19ce47d32f.png?v=1772346852',

    price: '£39.99/month',
    doseCopy: 'Taken with main meals that contain fat.',

    tags: [{ variant: 'danger', label: 'Out of stock' }],
    status: 'out_of_stock',

    startingStrengthId: 'orlos-60',

    strengths: [
      {
        id: 'orlos-60',
        label: '60 mg – £49',
        isStarting: true,
        variantId: null,          // not provided by you yet
        sellingPlanId: null,
        priceText: '£49/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0882/7306/0174/files/orlos_cfa1d1e4-34ea-43b2-9d6a-ff19ce47d32f.png?v=1772346852'
      }
    ],

    accordions: [
      { title: 'How it works', content: 'Orlos works by blocking about 25% of the fat you eat from being digested.' },
      { title: 'Dose schedule', content: 'Taken orally three times a day with meals.' },
      { title: 'How to take', content: 'Swallow whole with water.' },
      { title: 'Potential common side effects', content: 'Wind (flatulence) with or without oily spotting, sudden bowel motions, soft stools.' },
      { title: 'Important safety information', content: 'Do not take if you have chronic malabsorption syndrome or cholestasis.' }
    ]
  }
};

// ✅ ADD THIS RIGHT HERE (after TREATMENT_PRODUCTS, before if (!root) return)
const PLAN_VARIANT_IDS = Object.values(TREATMENT_PRODUCTS)
  .flatMap(p => p.strengths || [])
  .map(s => s.variantId)
  .filter(Boolean);

  const root = document.querySelector('[data-quiz-root]');
const intro = document.querySelector('[data-quiz-intro]');
const backButton = document.querySelector('[data-quiz-back]');
const progressText = document.querySelector('[data-quiz-progress-text]');
const progressBarFill = document.querySelector('[data-quiz-progress-bar]');

if (!root) return; // don't run if quiz root not present
function scrollQuizToTop() {
  const shell = root.closest('.xo-quiz-shell') || root;
  const rect = shell.getBoundingClientRect();
  const top = window.pageYOffset + rect.top - 16;
  window.scrollTo({ top, behavior: 'smooth' });
}
  // --- CONFIG ---
  const QUIZ_ENDPOINT =
    'https://script.google.com/macros/s/AKfycby7XjjzrlKBqZNPakIU23apvRd_T5jS17JZ69SlikCS5wXEN2Dj5Uyj8ygPimxHFEWLsw/exec';

  const urlParams = new URLSearchParams(window.location.search);
  const QUIZ_CATEGORY = urlParams.get('category') || 'weight';
  const QUIZ_VERSION = QUIZ_CATEGORY + '_v1';

const QUIZ_ANSWERS = {};
let currentStepIndex = 0;

// Optional custom progress map for weight category (per step index)
const WEIGHT_STEP_PROGRESS = [
  8,   // 0: height_weight
  13,  // 1: journey
  17,  // 2: reasons
  21,  // 3: past_methods
  25,  // 4: info_feel_better
  29,  // 5: email
  33,  // 6: sex_at_birth
  38,  // 7: current_situation
  46,  // 8: ethnicity          (you can tweak this if needed)
  50,  // 9: info_medical_history
  54,  // 10: using_medication          ← Are you using weight loss medication?
  58,  // 11: which_medication          ← Which weight loss medication…
  63,  // 12: other_conditions
  71, // 13: weight.eating_disorder
  79, // 14: weight.other_medical
  83, // 15: weight.regular_meds
  88, // 16: weight.allergies
  92, // 17: weight.gp_details
  96  // 18: dob
];

let CURRENT_SITUATION_MODE = 'options';

const WEIGHT_CURRENT_SITUATION_SAFETY_PROGRESS = 42;
let GP_DETAILS_MODE = 'search'; // 'search' or 'manual'

  // State for the height & weight step (metric / imperial)
  const HEIGHT_WEIGHT_STATE = {
    system: 'metric',
    metric: {
      height_cm: '',
      weight_kg: '',
      goal_kg: ''
    },
    imperial: {
      h_ft: '',
      h_in: '',
      w_st: '',
      w_lbs: '',
      g_st: '',
      g_lbs: ''
    }
  };

  // --- STEP DEFINITIONS (NO INTRO, intro is in Liquid) ---
  const QUIZ_STEPS_BY_CATEGORY = {
    weight: [
          {
      id: 'weight.height_weight',
      type: 'height_weight',
      text: 'What is your height & weight?',
      required: true
    },

    // NEW STEP: Your estimated journey (summary card)
    {
      id: 'weight.journey',
      type: 'journey',
      text: 'Your estimated journey'
    },

      {
        id: 'weight.reasons',
        type: 'choice',
        text: 'What are your main reasons for wanting to lose weight?',
        subtext: 'Tick all that apply',
        multi: true,
        required: true,
        options: [
          { label: 'Feeling and looking healthier', value: 'feeling_looking_healthier' },
          { label: 'Return to former weight', value: 'return_former_weight' },
          { label: 'Improving mood, mental health', value: 'improving_mood_mental_health' },
          { label: 'Avoid health risks', value: 'avoid_health_risks' },
          { label: 'Just exploring', value: 'just_exploring' }
        ]
      },
      {
        id: 'weight.past_methods',
        type: 'choice',
        text: 'What have you done in the past to lose weight?',
        subtext: 'Tick all that apply',
        multi: true,
        required: true,
        options: [
          { label: 'Changing diet', value: 'changing_diet' },
          { label: 'Exercise', value: 'exercise' },
          { label: 'Medication', value: 'medication' },
          { label: 'Professional help', value: 'professional_help' },
          { label: 'First time', value: 'first_time' }
        ]
      },
      {
        id: 'weight.info_feel_better',
        type: 'info',
        text: 'At XO, we know that how you feel matters just as much as what you see on the scale.',
        subtext:
          '92% of customers feel healthier overall since starting weight loss treatment plans through XO.*',
        buttonLabel: 'Continue'
      },
      {
        id: 'weight.email',
        type: 'email',
        text: "Let’s help you hit your weight loss goals",
        required: true
      },
      {
        id: 'weight.sex_at_birth',
        type: 'choice',
        text: 'What was your sex assigned at birth?',
        multi: false,
        required: true,
        options: [
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' }
        ]
      },
      {
        id: 'weight.current_situation',
        type: 'choice',
        text: 'What is your current situation?',
        multi: false,
        required: true,
        options: [
          {
            label: "I am trying for a baby, but I'm not pregnant yet",
            value: 'trying_for_baby_not_pregnant'
          },
          { label: 'I am breastfeeding', value: 'breastfeeding' },
          { label: 'I am pregnant', value: 'pregnant' },
          { label: 'None of these apply to me', value: 'none_apply' }
        ]
      },
      {
        id: 'weight.ethnicity',
        type: 'choice',
        text: 'How would you describe your ethnicity?',
        subtext:
          "What's considered a healthy weight can differ by ethnic background. Share yours so we can provide the right care.",
        multi: false,
        required: true,
        options: [
          { label: 'White or Caucasian', value: 'white_caucasian' },
          { label: 'Asian, Asian British, South Asian', value: 'asian' },
          { label: 'Black, Black British, Caribbean or African', value: 'black' },
          { label: 'Middle Eastern', value: 'middle_eastern' },
          { label: 'Other', value: 'other' },
          { label: 'I prefer not to answer', value: 'prefer_not_to_answer' }
        ]
      },
      {
        id: 'weight.info_medical_history',
        type: 'info',
        text: 'Let’s learn more about your medical history.',
        subtext: 'This will help us determine treatment eligibility and personalise your plan.',
        buttonLabel: 'Continue'
      },

       {
  id: 'weight.using_medication',
  type: 'choice',
  text: 'Are you using weight loss medication?',
  multi: false,
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No',  value: 'no' }
  ]
},
{
  id: 'weight.which_medication',
  type: 'choice',
  text: 'Which weight loss medication are you taking?',
  multi: false,
  required: true,
  options: [
    { label: 'Mounjaro', value: 'mounjaro' },
    { label: 'Wegovy',   value: 'wegovy' },
    { label: 'Ozempic',  value: 'ozempic' },
    { label: 'Saxenda',  value: 'saxenda' },
    { label: 'Orlistat', value: 'orlistat' },
    { label: 'Other',    value: 'other' }
  ]
},



     {
  id: 'weight.other_conditions',
  type: 'choice',
  text: 'Do you have, or have you ever had, any of the following conditions?',
  subtext: 'Please select all that apply.',
  multi: true,              // we’ll handle multi manually
  required: false,
  options: [
    { label: 'Type 1 Diabetes, Diabetic retinopathy/diabetic eye disease', value: 'type1_diabetes' },
    { label: 'Moderate to severe chronic kidney disease', value: 'ckd' },
    { label: 'Severe liver impairment', value: 'liver' },
    { label: 'Moderate to severe heart failure', value: 'heart_failure' },
    { label: 'Pancreatitis', value: 'pancreatitis' },
    { label: 'Multiple endocrine neoplasia type 2 (MEN 2)', value: 'men2' },
    { label: 'Currently being treated for cancer', value: 'cancer_treatment' },
    { label: 'Medullary thyroid cancer (MTC) *Personal or family history', value: 'mtc' },
    { label: 'Gallbladder problems or Gallstones', value: 'gallbladder' },
    { label: 'Inflammatory bowel disease', value: 'ibd' },
    { label: 'Gastroparesis', value: 'gastroparesis' },
    { label: 'Previous stroke', value: 'stroke' },
    { label: 'Tachycardia (fast heart rate)', value: 'tachycardia' },
    { label: 'Bariatric surgery (last 2 years)', value: 'bariatric' },
    { label: 'Epilepsy', value: 'epilepsy' },
    { label: 'Organ transplant', value: 'organ_transplant' },
    { label: 'None of the above', value: 'none_of_the_above' }  // last option
  ]
},


{
  id: 'weight.eating_disorder',
  type: 'choice',
  text: 'Have you ever had an eating disorder?',
  multi: false,
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No',  value: 'no' }
  ]
},
{
  id: 'weight.other_medical',
  type: 'choice',
  text: 'Do you have any other medical conditions or illnesses?',
  multi: false,
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No',  value: 'no' }
  ]
},
{
  id: 'weight.regular_meds',
  type: 'choice',
  text: 'Do you take any regular medications?',
  subtext: 'Tick all that apply',
  multi: true,
  required: false,
  options: [
    { label: 'Metformin', value: 'metformin' },
    { label: 'SGLT-2 (Empagliflozin, Dapagliflozin)', value: 'sglt2' },
    { label: 'Insulin', value: 'insulin' },
    { label: 'Sulfonylureas (e.g. Gliclazide, Glimepiride)', value: 'sulfonylureas' },
    { label: 'Levothyroxine', value: 'levothyroxine' },
    { label: 'Anticoagulants (e.g. warfarin, apixaban, rivaroxaban, dabigatran, edoxaban)', value: 'anticoagulants' },
{ label: 'Other medication not listed', value: 'other' },
{ label: 'I take no regular medications', value: 'none' }
  ]
},

{
  id: 'weight.allergies',
  type: 'choice',
  text: 'Are you allergic to any medicines or substances?',
  multi: false,
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No',  value: 'no' }
  ]
},
{
  id: 'weight.gp_details',
  type: 'input',  // type is irrelevant; we override it with a custom renderer
  text: 'Can you share your GP’s details?',
  subtext: 'Search for your GP by entering your postcode.'
},


     {
  id: 'weight.dob',
  type: 'input',              // we override this with a custom renderer
  text: 'One final thing...',
  required: true
}
    ],
    hairloss: []
  };

  function getSteps() {
    return QUIZ_STEPS_BY_CATEGORY[QUIZ_CATEGORY] || [];
  }

function updateProgress() {
  const steps = getSteps();
  const total = steps.length || 1;

  let percent;

  if (QUIZ_CATEGORY === 'weight') {
    // If we have an explicit mapping for this step, use it
    if (currentStepIndex < WEIGHT_STEP_PROGRESS.length) {
      percent = WEIGHT_STEP_PROGRESS[currentStepIndex];
    } else {
      // After the last mapped index, spread evenly up to 100%
      const lastIndex = WEIGHT_STEP_PROGRESS.length - 1; // 1
      const startValue = WEIGHT_STEP_PROGRESS[lastIndex]; // 13

      const remainingSteps = total - (lastIndex + 1);     // total - 2
      const stepsAfter = currentStepIndex - lastIndex;    // 1,2,...

      if (remainingSteps > 0) {
        const fraction = Math.max(0, Math.min(stepsAfter / remainingSteps, 1));
        percent = Math.round(startValue + fraction * (100 - startValue));
      } else {
        percent = startValue;
      }
    }
  } else {
    // Default linear behaviour for other categories
    const fraction = (currentStepIndex + 1) / total;
    const clamped = Math.max(0, Math.min(fraction, 1));
    // 4% reserved for intro
    percent = Math.round(4 + clamped * 96);
  }

  percent = Math.max(0, Math.min(percent, 100));

  if (progressText) {
    progressText.textContent = `${percent}%`;
  }
  if (progressBarFill) {
    progressBarFill.style.width = `${percent}%`;
  }

}

  // --- Answer storage helpers ---

  function recordAnswer(questionId, questionText, value) {
    QUIZ_ANSWERS[questionId] = { text: questionText, value };
  }

  function toggleMultiAnswer(questionId, questionText, optionValue) {
    if (!QUIZ_ANSWERS[questionId]) {
      QUIZ_ANSWERS[questionId] = { text: questionText, value: [] };
    }
    const arr = QUIZ_ANSWERS[questionId].value;
    const idx = arr.indexOf(optionValue);
    if (idx === -1) arr.push(optionValue);
    else arr.splice(idx, 1);
  }

  // --- Rendering (steps 0..N inside data-quiz-root) ---

  function renderCurrentStep() {
    const steps = getSteps();
    const step = steps[currentStepIndex];
    if (!step) return onQuizComplete();

   root.innerHTML = '';

const slide = document.createElement('div');
slide.className = 'quiz-slide quiz-slide--enter';
root.appendChild(slide);

// trigger animation
requestAnimationFrame(() => slide.classList.add('quiz-slide--enter-active'));

const container = document.createElement('div');
container.className = 'quiz-step';
slide.appendChild(container);

       if (step.type === 'height_weight') {
      renderHeightWeightStep(step, container);
      updateProgress();
      return;
    }

    if (step.type === 'journey') {
      renderJourneyStep(step, container);
      updateProgress();
      return;
    }

  if (step.id === 'weight.reasons') {
    renderReasonsStep(step, container);
    updateProgress();
    return;              
  }

  
  if (step.id === 'weight.past_methods') {
    renderPastMethodsStep(step, container);
    updateProgress();
    return;
  }

  if (step.id === 'weight.info_feel_better') {
    renderFeelInfoStep(step, container);
    updateProgress();
    return;       
  }


  if (step.id === 'weight.email') {
    renderWeightEmailStep(step, container);
    updateProgress();
    return;              
  }

   if (step.id === 'weight.sex_at_birth') {
    renderSexAtBirthStep(step, container);
    updateProgress();
    return;
  }

    if (step.id === 'weight.current_situation') {
    renderCurrentSituationStep(step, container);
    updateProgress();
    return;
  }
 
    if (step.id === 'weight.ethnicity') {
    renderEthnicityStep(step, container);
    updateProgress();
    return;
  }


   if (step.id === 'weight.using_medication') {
    renderUsingMedicationStep(step, container);
    updateProgress();
    return;
  }

  if (step.id === 'weight.which_medication') {
    renderWhichMedicationStep(step, container);
    updateProgress();
    return;
  }


  if (step.id === 'weight.other_conditions') {
  renderOtherConditionsStep(step, container);
  updateProgress();
  return;
}


if (step.id === 'weight.eating_disorder') {
  renderEatingDisorderStep(step, container);
  updateProgress();
  return;
}

if (step.id === 'weight.other_medical') {
  renderOtherMedicalStep(step, container);
  updateProgress();
  return;
}

if (step.id === 'weight.regular_meds') {
  renderRegularMedsStep(step, container);
  updateProgress();
  return;
}

  if (step.id === 'weight.allergies') {
    renderAllergiesStep(step, container);
    updateProgress();
    return;
  }

  if (step.id === 'weight.gp_details') {
    renderGpDetailsStep(step, container);
    updateProgress();
    return;
  }

  if (step.id === 'weight.dob') {
  renderDobConfirmStep(step, container);
  updateProgress();
  return;
}
    // Common title/subtext for other steps...

    if (step.text) {
      const q = document.createElement('h2');
      q.textContent = step.text;
      q.style.textAlign = 'center';
      q.style.marginBottom = '8px';
      container.appendChild(q);
    }

    if (step.subtext) {
      const p = document.createElement('p');
      p.textContent = step.subtext;
      p.style.textAlign = 'center';
      p.style.color = '#666';
      p.style.marginBottom = '16px';
      container.appendChild(p);
    }

    if (step.type === 'info') {
      const btn = createButton(step.buttonLabel || 'Continue');
      btn.style.display = 'block';
      btn.style.margin = '24px auto 0';
      btn.addEventListener('click', goToNextStep);
      container.appendChild(btn);
      updateProgress();
      return;
    }

     
        // Custom layout + logic for "reasons" step
    if (step.id === 'weight.reasons') {
      renderReasonsStep(step, container);
      updateProgress();
      return;
    }

  
    if (step.type === 'choice') {
      const selectedSet = new Set(
        (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || []
      );

      step.options.forEach((opt) => {
        const btn = createOptionButton(opt.label);
        if (step.multi && selectedSet.has(opt.value)) {
          btn.classList.add('is-selected');
          btn.style.borderColor = '#666';
        }
        container.appendChild(btn);
      });

      if (step.multi) {
        const nextBtn = createButton('Next');
        nextBtn.style.display = 'block';
        nextBtn.style.margin = '24px auto 0';
        nextBtn.addEventListener('click', () => {
          if (step.required && !hasAnswer(step.id)) {
            alert('Please select at least one option.');
            return;
          }
          goToNextStep();
        });
        container.appendChild(nextBtn);
      }

      updateProgress();
      return;
    }

    if (step.type === 'email') {
      const input = document.createElement('input');
      input.type = 'email';
      input.placeholder = 'Email address';
      input.style.display = 'block';
      input.style.margin = '0 auto 12px';
      input.style.padding = '10px 12px';
      input.style.borderRadius = '4px';
      input.style.border = '1px solid #ddd';
      input.style.maxWidth = '360px';
      container.appendChild(input);

      const consentWrapper = document.createElement('div');
      consentWrapper.style.margin = '0 auto 12px';
      consentWrapper.style.maxWidth = '360px';

      const consent = document.createElement('input');
      consent.type = 'checkbox';
      consent.id = 'quiz-consent';
      consentWrapper.appendChild(consent);

      const label = document.createElement('label');
      label.htmlFor = 'quiz-consent';
      label.style.marginLeft = '6px';
      label.textContent = 'I agree to the terms and privacy policy';
      consentWrapper.appendChild(label);

      container.appendChild(consentWrapper);

      const btn = createButton('Continue');
      btn.style.display = 'block';
      btn.style.margin = '24px auto 0';
      btn.addEventListener('click', () => {
        const emailVal = input.value.trim();
        if (!emailVal) {
          alert('Please enter your email address.');
          return;
        }
        if (!consent.checked) {
          alert('Please agree to the terms.');
          return;
        }
        recordAnswer(step.id, 'Email', emailVal);
        goToNextStep();
      });
      container.appendChild(btn);
      updateProgress();
      return;
    }

    if (step.type === 'input') {
      const input = document.createElement('input');
      input.type = step.inputType || 'text';
      input.style.display = 'block';
      input.style.margin = '0 auto 12px';
      input.style.padding = '10px 12px';
      input.style.borderRadius = '4px';
      input.style.border = '1px solid #ddd';
      input.style.maxWidth = '360px';

      const existing =
        QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
      if (existing) input.value = existing;

      container.appendChild(input);

      const btn = createButton('Next');
      btn.style.display = 'block';
      btn.style.margin = '24px auto 0';
      btn.addEventListener('click', () => {
        const val = input.value.trim();
        if (step.required && !val) {
          alert('This field is required.');
          return;
        }
        recordAnswer(step.id, step.text, val);
        goToNextStep();
      });
      container.appendChild(btn);
      updateProgress();
      return;
    }
    updateProgress();
  }


  function setProgressPercent(percent) {
  percent = Math.max(0, Math.min(percent, 100));
  if (progressText) progressText.textContent = `${percent}%`;
  if (progressBarFill) progressBarFill.style.width = `${percent}%`;
}

 function createButton(label) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'xo-quiz-button';
  btn.innerHTML =
    `<span>${label}</span>` +
    `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true" class="xo-quiz-button__icon">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
     </svg>`;
  return btn;
}

  function createOptionButton(label) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = label;
    btn.style.display = 'block';
    btn.style.width = '100%';
    btn.style.margin = '8px 0';
    btn.style.padding = '12px 16px';
    btn.style.textAlign = 'left';
    btn.style.borderRadius = '4px';
    btn.style.border = '1px solid #ddd';
    btn.style.background = '#fff';
    btn.style.cursor = 'pointer';
    btn.classList.add('quiz-option');
    return btn;
  }

  function hasAnswer(questionId) {
    const a = QUIZ_ANSWERS[questionId];
    if (!a) return false;
    if (Array.isArray(a.value)) return a.value.length > 0;
    return (
      a.value !== undefined &&
      a.value !== null &&
      String(a.value).trim() !== ''
    );
  }

  // --- Height & weight rendering / validation (same as before) ---

 /* ===========================================
   HEIGHT & WEIGHT RENDERING / VALIDATION
   =========================================== */

function renderHeightWeightStep(step, container) {
  // Title
  const title = document.createElement('h2');
  title.textContent = step.text;
  title.style.textAlign = 'center';
  title.style.marginBottom = '16px';
  container.appendChild(title);

  // Metric / Imperial toggle
  const toggle = document.createElement('div');
  toggle.className = 'quiz-toggle';

  const metricBtn = document.createElement('button');
  metricBtn.type = 'button';
  metricBtn.textContent = 'Metric';
  metricBtn.className = 'quiz-toggle__option';

  const imperialBtn = document.createElement('button');
  imperialBtn.type = 'button';
  imperialBtn.textContent = 'Imperial';
  imperialBtn.className = 'quiz-toggle__option';

  function updateToggleActive() {
    const isMetric = HEIGHT_WEIGHT_STATE.system === 'metric';
    metricBtn.classList.toggle('quiz-toggle__option--active', isMetric);
    imperialBtn.classList.toggle('quiz-toggle__option--active', !isMetric);
  }

  metricBtn.addEventListener('click', () => {
    HEIGHT_WEIGHT_STATE.system = 'metric';
    renderCurrentStep(); // re-render this step
  });

  imperialBtn.addEventListener('click', () => {
    HEIGHT_WEIGHT_STATE.system = 'imperial';
    renderCurrentStep();
  });

  updateToggleActive();
  toggle.appendChild(metricBtn);
  toggle.appendChild(imperialBtn);
  container.appendChild(toggle);

  // Fields wrapper
  const fieldsWrapper = document.createElement('div');
  fieldsWrapper.className = 'quiz-hw-fields';

  if (HEIGHT_WEIGHT_STATE.system === 'metric') {
    renderMetricHeightWeight(fieldsWrapper);
  } else {
    renderImperialHeightWeight(fieldsWrapper);
  }

  container.appendChild(fieldsWrapper);


    // Error card placeholder (hidden by default)
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-hw-error';
  errorBox.setAttribute('data-hw-error', 'true');
  errorBox.style.display = 'none';
  container.appendChild(errorBox);
  

  // "Why we ask" card
  const infoCard = document.createElement('div');
  infoCard.className = 'quiz-info-card';
  infoCard.innerHTML =
    '<strong>Why we ask</strong>' +
    '<p>We use this to calculate your BMI. If you\'re unsure of your measurements, please take a moment to check before continuing. False or inaccurate information may lead to severe illness or harm.</p>';
  container.appendChild(infoCard);

  // Continue button
   const btn = createButton('Continue');
  btn.style.display = 'block';
  btn.style.margin = '24px auto 0';
  btn.addEventListener('click', () => {
    const valid = validateHeightWeight(fieldsWrapper);
    if (valid) {
      const value = JSON.parse(JSON.stringify(HEIGHT_WEIGHT_STATE));
      recordAnswer(step.id, step.text, value);
      goToNextStep();
    }
  });
  container.appendChild(btn);
}

/* === METRIC FIELDS === */
/* Height (cm), Weight (kg), Goal Weight (kg) */

function renderMetricHeightWeight(wrapper) {
  const s = HEIGHT_WEIGHT_STATE.metric;
  wrapper.innerHTML = '';

  wrapper.appendChild(
    createMetricRow(
      'Height',
      'cm',
      s.height_cm,
      (val) => (HEIGHT_WEIGHT_STATE.metric.height_cm = val),
      'hw-m-height'
    )
  );
  wrapper.appendChild(
    createMetricRow(
      'Weight',
      'kg',
      s.weight_kg,
      (val) => (HEIGHT_WEIGHT_STATE.metric.weight_kg = val),
      'hw-m-weight'
    )
  );
  wrapper.appendChild(
    createMetricRow(
      'Goal Weight',
      'kg',
      s.goal_kg,
      (val) => (HEIGHT_WEIGHT_STATE.metric.goal_kg = val),
      'hw-m-goal'
    )
  );
}

function createMetricRow(labelText, unit, value, onChange, id) {
  const row = document.createElement('div');
  row.className = 'quiz-input-row';

  const label = document.createElement('label');
  label.className = 'quiz-input-label';
  label.textContent = labelText;
  row.appendChild(label);

  const wrap = document.createElement('div');
  wrap.className = 'quiz-input-wrap';
  wrap.dataset.fieldId = id;

  const input = document.createElement('input');
  input.type = 'number';
  input.className = 'quiz-input';
  input.value = value || '';

  // On every change: update state + toggle error class
  input.addEventListener('input', () => {
    const v = input.value;
    onChange(v);

    const wrapEl = input.closest('[data-field-id]');
    if (!wrapEl) return;

    if (v.trim()) {
      wrapEl.classList.remove('quiz-input-error');
    } else {
      wrapEl.classList.add('quiz-input-error');
    }
  });

  wrap.appendChild(input);

  const unitSpan = document.createElement('span');
  unitSpan.className = 'quiz-input-unit';
  unitSpan.textContent = unit;
  wrap.appendChild(unitSpan);

  row.appendChild(wrap);
  return row;
}

/* === IMPERIAL FIELDS === */
/* Height: ft + in, Weight: st + lbs, Goal Weight: st + lbs */

function renderImperialHeightWeight(wrapper) {
  const s = HEIGHT_WEIGHT_STATE.imperial;
  wrapper.innerHTML = '';

  // Height
  wrapper.appendChild(
    createImperialHeightRow(
      'Height',
      'ft',
      'in',
      s.h_ft,
      s.h_in,
      (val) => (HEIGHT_WEIGHT_STATE.imperial.h_ft = val),
      (val) => (HEIGHT_WEIGHT_STATE.imperial.h_in = val),
      'hw-i-hft',
      'hw-i-hin'
    )
  );

  // Weight
  wrapper.appendChild(
    createImperialRowTwo(
      'Weight',
      'st',
      'lbs',
      s.w_st,
      s.w_lbs,
      (val) => (HEIGHT_WEIGHT_STATE.imperial.w_st = val),
      (val) => (HEIGHT_WEIGHT_STATE.imperial.w_lbs = val),
      'hw-i-wst',
      'hw-i-wlbs'
    )
  );

  // Goal Weight
  wrapper.appendChild(
    createImperialRowTwo(
      'Goal Weight',
      'st',
      'lbs',
      s.g_st,
      s.g_lbs,
      (val) => (HEIGHT_WEIGHT_STATE.imperial.g_st = val),
      (val) => (HEIGHT_WEIGHT_STATE.imperial.g_lbs = val),
      'hw-i-gst',
      'hw-i-glbs'
    )
  );
}

function createImperialHeightRow(
  labelText,
  unitLeft,
  unitRight,
  valueLeft,
  valueRight,
  onChangeLeft,
  onChangeRight,
  idLeft,
  idRight
) {
  const row = document.createElement('div');
  row.className = 'quiz-input-row';

  const label = document.createElement('label');
  label.className = 'quiz-input-label';
  label.textContent = labelText;
  row.appendChild(label);

  const twoWrap = document.createElement('div');
  twoWrap.className = 'quiz-input-row--two';

  twoWrap.appendChild(
    createImperialField(unitLeft, valueLeft, onChangeLeft, idLeft)
  );
  twoWrap.appendChild(
    createImperialField(unitRight, valueRight, onChangeRight, idRight)
  );

  row.appendChild(twoWrap);
  return row;
}

function createImperialRowTwo(
  labelText,
  unitLeft,
  unitRight,
  valueLeft,
  valueRight,
  onChangeLeft,
  onChangeRight,
  idLeft,
  idRight
) {
  const row = document.createElement('div');
  row.className = 'quiz-input-row';

  const label = document.createElement('label');
  label.className = 'quiz-input-label';
  label.textContent = labelText;
  row.appendChild(label);

  const twoWrap = document.createElement('div');
  twoWrap.className = 'quiz-input-row--two';

  twoWrap.appendChild(
    createImperialField(unitLeft, valueLeft, onChangeLeft, idLeft)
  );
  twoWrap.appendChild(
    createImperialField(unitRight, valueRight, onChangeRight, idRight)
  );

  row.appendChild(twoWrap);
  return row;
}

function createImperialField(unit, value, onChange, id) {
  const wrap = document.createElement('div');
  wrap.className = 'quiz-input-wrap';
  wrap.dataset.fieldId = id;

  const input = document.createElement('input');
  input.type = 'number';
  input.className = 'quiz-input';
  input.value = value || '';

  input.addEventListener('input', () => {
    const v = input.value;
    onChange(v);

    const wrapEl = input.closest('[data-field-id]');
    if (!wrapEl) return;

    if (v.trim()) {
      wrapEl.classList.remove('quiz-input-error');
    } else {
      wrapEl.classList.add('quiz-input-error');
    }
  });

  wrap.appendChild(input);

  const unitSpan = document.createElement('span');
  unitSpan.className = 'quiz-input-unit';
  unitSpan.textContent = unit;
  wrap.appendChild(unitSpan);

  return wrap;
}

/* === VALIDATION === */
function validateHeightWeight(wrapper) {
  // 1) Clear previous empty-field errors
  wrapper.querySelectorAll('[data-field-id]').forEach((el) => {
    el.classList.remove('quiz-input-error');
  });

  // 2) Clear previous error card
  const container = wrapper.parentElement; // parent div inside quiz-step
  const errorBox = container.querySelector('[data-hw-error]');
  if (errorBox) {
    errorBox.style.display = 'none';
    errorBox.innerHTML = '';
  }

  let hasEmpty = false;

  // 3) Mark empty number inputs as field errors first
  const inputs = wrapper.querySelectorAll('input[type="number"]');
  inputs.forEach((input) => {
    const val = input.value.trim();
    if (!val) {
      const wrap = input.closest('[data-field-id]');
      if (wrap) wrap.classList.add('quiz-input-error');
      hasEmpty = true;
    }
  });

  // If any required field is empty, stop here (no range message yet)
  if (hasEmpty) {
    return false;
  }

  // 4) Compute height (cm) and weight (kg) from state
  let heightCm = 0;
  let weightKg = 0;

  if (HEIGHT_WEIGHT_STATE.system === 'metric') {
    heightCm = parseFloat(HEIGHT_WEIGHT_STATE.metric.height_cm) || 0;
    weightKg = parseFloat(HEIGHT_WEIGHT_STATE.metric.weight_kg) || 0;
  } else {
    const ft = parseFloat(HEIGHT_WEIGHT_STATE.imperial.h_ft) || 0;
    const inch = parseFloat(HEIGHT_WEIGHT_STATE.imperial.h_in) || 0;
    const st = parseFloat(HEIGHT_WEIGHT_STATE.imperial.w_st) || 0;
    const lbs = parseFloat(HEIGHT_WEIGHT_STATE.imperial.w_lbs) || 0;

    const totalInches = ft * 12 + inch;
    heightCm = totalInches * 2.54;

    weightKg = st * 6.35029318 + lbs * 0.45359237;
  }

  // 5) Range checks with error messages
  function showErrorMessage(msg) {
    if (!errorBox) return;
    errorBox.innerHTML =
      '<div class="quiz-hw-error__icon">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"' +
             ' viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
             ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round"' +
             ' aria-hidden="true">' +
          '<circle cx="12" cy="12" r="10"></circle>' +
          '<line x1="12" x2="12" y1="8" y2="12"></line>' +
          '<line x1="12" x2="12.01" y1="16" y2="16"></line>' +
        '</svg>' +
      '</div>' +
      '<div class="quiz-hw-error__text">' + msg + '</div>';

    errorBox.style.display = 'flex';
  }

  // Height: 120–240 cm
  if (heightCm < 120 || heightCm > 240) {
    showErrorMessage('Please enter a valid height between 120 cm and 240 cm.');
    return false;
  }

  // Weight: 40–450 kg
  if (weightKg < 40 || weightKg > 450) {
    showErrorMessage('Please enter a valid weight between 40 kg and 450 kg.');
    return false;
  }

    // NEW: BMI check – block < 27
  const heightM = heightCm / 100;
  const bmi = heightM > 0 ? weightKg / (heightM * heightM) : 0;

  if (bmi < 27) {
    showErrorMessage('Based on your current answer, we cannot offer you medication for this condition.');
    return false;
  }
  return true;
}


function computeJourneyMetrics(forProductId) {
  const hwAnswer = QUIZ_ANSWERS['weight.height_weight'];
  if (!hwAnswer || !hwAnswer.value) return null;

  const hw = hwAnswer.value;
  const system = hw.system || 'metric';

  let heightCm = 0;
  let weightKg = 0;

  if (system === 'metric') {
    const m = hw.metric || {};
    heightCm = parseFloat(m.height_cm) || 0;
    weightKg = parseFloat(m.weight_kg) || 0;
  } else {
    const im = hw.imperial || {};
    const ft = parseFloat(im.h_ft) || 0;
    const inch = parseFloat(im.h_in) || 0;
    const st = parseFloat(im.w_st) || 0;
    const lbs = parseFloat(im.w_lbs) || 0;

    heightCm = (ft * 12 + inch) * 2.54;
    weightKg = st * 6.35029318 + lbs * 0.45359237;
  }

  const heightM = heightCm / 100;
  const bmi = heightM > 0 ? weightKg / (heightM * heightM) : 0;

  // Match 1st code (loss differs by product if passed; default mounjaro-like)
  const LOSS_BY_PRODUCT = { mounjaro: 22.5, wegovy: 15, orlos: 5 };
  const POTENTIAL_LOSS_PCT = LOSS_BY_PRODUCT[forProductId] ?? 22.5;

  const endWeightKg = weightKg * (1 - POTENTIAL_LOSS_PCT / 100);
  const lossKg = weightKg - endWeightKg;

  return { system, bmi, potentialLossPct: POTENTIAL_LOSS_PCT, weightKg, endWeightKg, lossKg };
}


function renderJourneyStep(step, container) {
  const metrics = computeJourneyMetrics();
  const bmiText = metrics ? metrics.bmi.toFixed(1) : '--';
  const lossPctText = metrics ? `${metrics.potentialLossPct.toFixed(1)}%` : '--';
  const currentText = metrics ? `${Math.round(metrics.weightKg)} kg` : '--';
  const endText = metrics ? `${Math.round(metrics.endWeightKg)} kg` : '--';
  const lossText = metrics ? `${Math.round(metrics.lossKg)} kg` : '--';

  container.innerHTML = `
    <div class="journey">
      <h2 class="journey__title">${step.text || 'Your estimated journey'}</h2>

      <div class="journey__metrics">
        <div class="journey__metric">
          <div class="journey__metricLabel">Current BMI</div>
          <div class="journey__metricValue1">${bmiText}</div>
        </div>
        <div class="journey__metric">
          <div class="journey__metricLabel">Potential Loss</div>
          <div class="journey__metricValue journey__metricValue--accent">${lossPctText}</div>
        </div>
      </div>

      <div class="journey__card">
        <div class="journey__cardTop">
          <div class="journey__smallLabel">Current weight</div>
          <div class="journey__bigValue1">${currentText}</div>
        </div>

        <div class="journey__graphWrap">
          <svg class="journey__svg" viewBox="0 0 542 286" preserveAspectRatio="none" aria-hidden="true">
            <defs>
              <clipPath id="journeyClip">
                <rect x="0" y="0" width="0" height="286" data-journey-clip></rect>
              </clipPath>
              <linearGradient id="journeyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stop-color="#A890FE" stop-opacity="0.7"></stop>
                <stop offset="95%" stop-color="#A890FE" stop-opacity="0"></stop>
              </linearGradient>
            </defs>

            <g clip-path="url(#journeyClip)">
              <path stroke-width="4" fill="url(#journeyGradient)" stroke="none"
                d="M0,76.246C15.056,84.105,30.111,91.963,45.167,98.881C60.222,105.799,75.278,112.033,90.333,117.754C105.389,123.474,120.444,128.568,135.5,133.205C150.556,137.843,165.611,141.91,180.667,145.578C195.722,149.246,210.778,152.401,225.833,155.214C240.889,158.026,255.944,160.383,271,162.455C286.056,164.526,301.111,166.199,316.167,167.643C331.222,169.088,346.278,170.19,361.333,171.121C376.389,172.052,391.444,172.699,406.5,173.231C421.556,173.763,436.611,174.067,451.667,174.314C466.722,174.561,481.778,174.675,496.833,174.713C511.889,174.751,526.944,174.761,542,174.77L542,286L0,286Z"></path>
              <path stroke="#A890FE" stroke-width="4" fill="none" stroke-linecap="round"
                d="M0,76.246C15.056,84.105,30.111,91.963,45.167,98.881C60.222,105.799,75.278,112.033,90.333,117.754C105.389,123.474,120.444,128.568,135.5,133.205C150.556,137.843,165.611,141.91,180.667,145.578C195.722,149.246,210.778,152.401,225.833,155.214C240.889,158.026,255.944,160.383,271,162.455C286.056,164.526,301.111,166.199,316.167,167.643C331.222,169.088,346.278,170.19,361.333,171.121C376.389,172.052,391.444,172.699,406.5,173.231C421.556,173.763,436.611,174.067,451.667,174.314C466.722,174.561,481.778,174.675,496.833,174.713C511.889,174.751,526.944,174.761,542,174.77"></path>
            </g>
          </svg>

          <div class="journey__marker" data-journey-marker>
            <span class="journey__lossPill">↓ ${lossText}</span>
            <span class="journey__dot"></span>
            <span class="journey__line"></span>
          </div>
        </div>

        <div class="journey__cardBottom">
          <div class="journey__smallLabel">Potential end weight</div>
          <div class="journey__bigValue">${endText}</div>
        </div>
      </div>

      <p class="journey__footnote">
  Lose up to ${metrics ? metrics.potentialLossPct.toFixed(1) : '22.5'}% body weight on GLP-1 weight loss programmes.
</p>
    </div>
  `;

  const btn = createButton('Continue');
  btn.style.display = 'block';
  btn.style.margin = '24px auto 0';
  btn.addEventListener('click', goToNextStep);
  container.appendChild(btn);

  const clipRect = container.querySelector('[data-journey-clip]');
  const marker = container.querySelector('[data-journey-marker]');
  if (!clipRect) return;

  const VIEW_W = 542;
  const duration = 1100;
  const start = performance.now();
  const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);

  if (marker) {
    marker.style.opacity = '0';
    marker.style.transform = 'translateY(-6px)';
  }

  function tick(now) {
    const rawT = Math.min((now - start) / duration, 1);
    const t = easeOutCubic(rawT);
    clipRect.setAttribute('width', String(VIEW_W * t));

    if (marker) {
      const m = Math.max(0, (rawT - 0.78) / 0.22);
      marker.style.opacity = String(m);
      marker.style.transform = `translateY(${(-6 + 6 * m).toFixed(2)}px)`;
    }

    if (rawT < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}



    
 function renderReasonsStep(step, container) {
  // --- Heading ---
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.margin = '0 0 4px';
    h.style.lineHeight = '1.3';         // tighter, like client
    container.appendChild(h);
  }

  // --- Subtext ("Tick all that apply") ---
  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.margin = '0 0 24px';
    p.style.fontSize = '14px';
    p.style.color = 'rgba(71, 70, 73, 0.7)';
    container.appendChild(p);
  }

  // Restore any existing answers
  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || [];
  const selected = new Set(existing);

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';

  const CHECK_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-reasons-check-icon">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  `;

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.dataset.value = opt.value;

    btn.innerHTML = `
      <span class="quiz-reasons-option__label">${opt.label}</span>
      <span class="quiz-reasons-check" aria-hidden="true">
        ${CHECK_SVG}
      </span>
    `;

    if (selected.has(opt.value)) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => {
      if (selected.has(opt.value)) {
        selected.delete(opt.value);
        btn.classList.remove('is-selected');
      } else {
        selected.add(opt.value);
        btn.classList.add('is-selected');
      }
      updateState();
    });

    optionsWrapper.appendChild(btn);
  });

  container.appendChild(optionsWrapper);

  // Error card
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.setAttribute('data-reasons-error', 'true');
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  // Next button
  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.disabled = true;
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    recordAnswer(step.id, step.text, Array.from(selected));
    goToNextStep();
  });

  // Initial state
  updateState();

  function updateState() {
    recordAnswer(step.id, step.text, Array.from(selected));

    const hasAny = selected.size > 0;
    const exploringSelected = selected.has('just_exploring');

    errorBox.style.display = exploringSelected ? 'flex' : 'none';

    const canProceed = hasAny && !exploringSelected;

    nextBtn.disabled = !canProceed;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !canProceed);
  }
}



  function renderPastMethodsStep(step, container) {
  // --- Heading only (no subtext) ---
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  // Restore existing selection
  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || [];
  const selected = new Set(existing);

  const optionsWrapper = document.createElement('div');
  // reuse same styles as reasons
  optionsWrapper.className = 'quiz-reasons-options';

  const CHECK_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-reasons-check-icon">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  `;

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.dataset.value = opt.value;

    btn.innerHTML = `
      <span class="quiz-reasons-option__label">${opt.label}</span>
      <span class="quiz-reasons-check" aria-hidden="true">
        ${CHECK_SVG}
      </span>
    `;

    if (selected.has(opt.value)) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => {
      if (selected.has(opt.value)) {
        selected.delete(opt.value);
        btn.classList.remove('is-selected');
      } else {
        selected.add(opt.value);
        btn.classList.add('is-selected');
      }
      updateState();
    });

    optionsWrapper.appendChild(btn);
  });

  container.appendChild(optionsWrapper);

  // Error card – reuse same look as reasons
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.setAttribute('data-past-error', 'true');
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  // Next button – disabled until valid
  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.disabled = true;
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    recordAnswer(step.id, step.text, Array.from(selected));
    goToNextStep();
  });

  // initial state
  updateState();

  function updateState() {
    recordAnswer(step.id, step.text, Array.from(selected));

    const hasAny = selected.size > 0;
    const firstTimeSelected = selected.has('first_time'); // last option's value

    errorBox.style.display = firstTimeSelected ? 'flex' : 'none';

    // Can proceed only if:
    // - at least one option selected
    // - AND "First time" is NOT selected
    const canProceed = hasAny && !firstTimeSelected;

    nextBtn.disabled = !canProceed;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !canProceed);
  }
}



function renderFeelInfoStep(step, container) {
  const heroImage =
  'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/happy_woman_celebrating_weight_loss_success_outdoors-B_gSUJKL.png?v=1767954900';

  const titleText = step.text || '';
  const statText = '92%';
  const statBody =
    step.subtext ||
    'of customers feel healthier overall since starting weight loss treatment plans through XO.*';

  const footnote =
    '*Based on feedback from over 200 customers between December 2023 and December 2025.';

  container.innerHTML = `
    <div class="feel">
      <h2 class="feel__title">${escapeHtml(titleText)}</h2>

      <div class="feel__hero" role="img" aria-label="Happy customer outdoors">
        <img class="feel__heroImg" src="${heroImage}" alt="" loading="lazy">
        <div class="feel__heroOverlay"></div>

        <div class="feel__heroContent">
          <div class="feel__stat">${escapeHtml(statText)}</div>
          <div class="feel__statText">${escapeHtml(statBody)}</div>
        </div>
      </div>

      <p class="feel__footnote">${escapeHtml(footnote)}</p>
    </div>
  `;

  const btn = createButton(step.buttonLabel || 'Continue');
  btn.style.display = 'block';
  btn.style.margin = '24px auto 0';
  btn.addEventListener('click', goToNextStep);
  container.appendChild(btn);
}

// helper
function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (m) => ({
    "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
  }[m]));
}

function renderWeightEmailStep(step, container) {
  const card = document.createElement('div');
  card.className = 'quiz-email-card';

  const title = document.createElement('h2');
  title.className = 'quiz-email-title';
  title.textContent = step.text || "Let’s help you hit your weight loss goals";
  card.appendChild(title);

  const fieldGroup = document.createElement('div');
  fieldGroup.className = 'quiz-email-field-group';

  const label = document.createElement('label');
  label.className = 'quiz-email-label';
  label.textContent = 'Email address';
  fieldGroup.appendChild(label);

  const inputWrap = document.createElement('div');
  inputWrap.className = 'quiz-email-input-wrap';

  const input = document.createElement('input');
  input.type = 'email';
  input.className = 'quiz-email-input';

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  if (existing) input.value = existing;

  inputWrap.appendChild(input);
  fieldGroup.appendChild(inputWrap);

  const helper = document.createElement('p');
  helper.className = 'quiz-email-helper';
  helper.textContent =
    "We'll use this to create your secure account and send you a one-time sign-in link. No password required.";
  fieldGroup.appendChild(helper);

  card.appendChild(fieldGroup);

  const termsRow = document.createElement('div');
  termsRow.className = 'quiz-email-terms-row';

  const termsButton = document.createElement('button');
  termsButton.type = 'button';
  termsButton.className = 'quiz-email-terms-toggle';
  termsButton.setAttribute('role', 'checkbox');
  termsButton.setAttribute('aria-checked', 'true');
  termsButton.dataset.state = 'checked';

  termsButton.innerHTML = `
    <span class="quiz-email-terms-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="lucide lucide-check">
        <path d="M20 6 9 17l-5-5"></path>
      </svg>
    </span>
  `;

  const termsLabel = document.createElement('span');
  termsLabel.className = 'quiz-email-terms-text';
  termsLabel.innerHTML =
    'I agree to the <a href="https://xomedical.co.uk/pages/terms-conditions" class="quiz-email-link">terms and conditions</a>, ' +
    '<a href="https://xomedical.co.uk/pages/terms-of-sale" class="quiz-email-link">terms of sale</a> and ' +
    '<a href="https://xomedical.co.uk/pages/privacy-policy" class="quiz-email-link">privacy policy</a>.';

  termsRow.appendChild(termsButton);
  termsRow.appendChild(termsLabel);
  card.appendChild(termsRow);

  container.appendChild(card);

  const btn = createButton('Continue');
  btn.disabled = true;
  btn.classList.add('xo-quiz-button--disabled');
  container.appendChild(btn);

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }
  function isTermsChecked() {
    return termsButton.dataset.state === 'checked';
  }

  function updateState(showErrors) {
    const emailVal = input.value.trim();
    const hasEmail = emailVal.length > 0;
    const emailOk = hasEmail && isValidEmail(emailVal);

    if (showErrors && !emailOk) inputWrap.classList.add('quiz-email-input-wrap--error');
    else if (emailOk) inputWrap.classList.remove('quiz-email-input-wrap--error');

    const canContinue = emailOk && isTermsChecked();
    btn.disabled = !canContinue;
    btn.classList.toggle('xo-quiz-button--disabled', !canContinue);

    if (hasEmail) {
      recordAnswer(step.id, 'Email', emailVal);
      QUIZ_ANSWERS.accepts_marketing = true;
    }
  } // ✅ IMPORTANT: updateState ends here

  termsButton.addEventListener('click', () => {
    const currentlyChecked = isTermsChecked();
    const newState = currentlyChecked ? 'unchecked' : 'checked';
    termsButton.dataset.state = newState;
    termsButton.setAttribute('aria-checked', String(!currentlyChecked));
    updateState(false);
  });

  input.addEventListener('input', () => updateState(false));
  input.addEventListener('blur', () => updateState(true));

  btn.addEventListener('click', () => {
    updateState(true);
    if (btn.disabled) return;
    recordAnswer(step.id, 'Email', input.value.trim());
    goToNextStep();
  });

  updateState(false);
}



function renderCurrentSituationStep(step, container) {
  // Heading (left aligned)
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || null;

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  const buttonsByValue = {};
  let selectedValue = existing || null;

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option quiz-situation-option';
    btn.dataset.value = opt.value;
    btn.textContent = opt.label;

    buttonsByValue[opt.value] = btn;
    optionsWrapper.appendChild(btn);

    btn.addEventListener('click', () => {
      handleSelect(opt.value, btn);
    });
  });

  // Red "Important Safety Information" card (breastfeeding / pregnant)
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  // Red "For your safety" card (1st option)
  const safetyBox = document.createElement('div');
  safetyBox.className = 'quiz-situation-safety';
  safetyBox.innerHTML = `
    <p class="quiz-situation-safety__title">For your safety:</p>
    <p class="quiz-situation-safety__text">
      GLP-1 medications like Wegovy®, Mounjaro®, or Liraglutide can be harmful during pregnancy.
      If you’re planning to become pregnant, it’s important to stop Wegovy at least two months
      before trying and Mounjaro at least one month before. You should use reliable contraception
      while taking these medications; for Mounjaro, non-oral (or barrier methods alongside the pill)
      work best. If you need emergency contraception, Mounjaro may make the morning after pill less
      effective, so a copper coil could be a better option.
    </p>
    <div class="quiz-situation-safety__confirm">
      <input type="checkbox" class="quiz-situation-safety__checkbox">
      <span class="quiz-situation-safety__confirm-text">
        I confirm I will inform my prescriber and stop treatment if I become pregnant,
        and I acknowledge the safety information provided.
      </span>
    </div>
  `;
  safetyBox.style.display = 'none';
  container.appendChild(safetyBox);

  const safetyCheckbox = safetyBox.querySelector('.quiz-situation-safety__checkbox');

  // Continue button (used for safety sub-step)
  const nextBtn = createButton('Continue');
  nextBtn.style.marginTop = '16px';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    goToNextStep();
  });

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-situation-option').forEach((el) => {
      el.classList.remove('is-selected', 'quiz-situation-option--danger');
    });
  }

  function showOptionsMode() {
    CURRENT_SITUATION_MODE = 'options';
    optionsWrapper.style.display = 'flex';
    errorBox.style.display = 'none';
    safetyBox.style.display = 'none';
    safetyCheckbox.checked = false;
    nextBtn.disabled = true;
    nextBtn.classList.add('xo-quiz-button--disabled');
    // progress for normal step is already set by updateProgress()
  }

  function showSafetyMode() {
    CURRENT_SITUATION_MODE = 'safety';
    optionsWrapper.style.display = 'none';
    errorBox.style.display = 'none';
    safetyBox.style.display = 'block';
    safetyCheckbox.checked = false;
    nextBtn.disabled = true;
    nextBtn.classList.add('xo-quiz-button--disabled');
    // bump progress to "sub-step" value
    setProgressPercent(WEIGHT_CURRENT_SITUATION_SAFETY_PROGRESS);
  }

  function handleSelect(value, btn) {
    selectedValue = value;
    recordAnswer(step.id, step.text, value);

    clearSelections();
    btn.classList.add('is-selected');

    // 4th option → skip safety, go straight to next quiz step
    if (value === 'none_apply') {
      CURRENT_SITUATION_MODE = 'options';
      goToNextStep();
      return;
    }

    // 2nd / 3rd options → red error, cannot proceed
    if (value === 'breastfeeding' || value === 'pregnant') {
      showOptionsMode();
      btn.classList.add('quiz-situation-option--danger');
      errorBox.style.display = 'flex';
      return;
    }

    // 1st option → show safety sub-step (hide options)
    if (value === 'trying_for_baby_not_pregnant') {
      showSafetyMode();
      return;
    }
  }

  // Safety checkbox enables/disables Continue in safety mode
  safetyCheckbox.addEventListener('change', () => {
    const ok =
      safetyCheckbox.checked &&
      selectedValue === 'trying_for_baby_not_pregnant' &&
      CURRENT_SITUATION_MODE === 'safety';
    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !ok);
  });

    // ---------- Initial render ----------
  if (existing && buttonsByValue[existing]) {
    const btn = buttonsByValue[existing];

    // 1st option
    if (existing === 'trying_for_baby_not_pregnant') {
      if (CURRENT_SITUATION_MODE === 'safety') {
        // we are in safety sub-step → show safety card
        handleSelect(existing, btn);
      } else {
        // we are in normal options mode → just highlight, no safety card
        showOptionsMode();
        btn.classList.add('is-selected');
      }
      return;
    }

    // 2nd / 3rd options → show red error card in options mode
    if (existing === 'breastfeeding' || existing === 'pregnant') {
      showOptionsMode();
      btn.classList.add('is-selected', 'quiz-situation-option--danger');
      errorBox.style.display = 'flex';
      return;
    }

    // 4th option (none_apply) → just highlight in options mode
    if (existing === 'none_apply') {
      showOptionsMode();
      btn.classList.add('is-selected');
      return;
    }
  }

  // Default: no previous answer → show options
  showOptionsMode();
}



function renderSexAtBirthStep(step, container) {
  // Heading – use default style (center) or left; client looks centered
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';     // or 'center' if you prefer
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || null;
  let selectedValue = existing || null;

  const steps = getSteps();
  const thisIndex = currentStepIndex;
  const currentSituationIndex = steps.findIndex(
    (s) => s.id === 'weight.current_situation'
  );

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) => {
      el.classList.remove('is-selected');
    });
  }

  function handleSelect(value, btn) {
    selectedValue = value;
    recordAnswer(step.id, step.text, value);

    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'male') {
      // Skip current_situation and jump directly to the step after it
      if (currentSituationIndex !== -1 && currentSituationIndex === thisIndex + 1) {
        currentStepIndex = thisIndex + 2; // step after current_situation
      } else {
        currentStepIndex = thisIndex + 1;
      }
      renderCurrentStep();
scrollQuizToTop();
    } else {
      // Female → go to current_situation like normal
      goToNextStep();
    }
  }

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    if (selectedValue === opt.value) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
    optionsWrapper.appendChild(btn);
  });
}


function renderEthnicityStep(step, container) {
  // --- Heading & subtext ---
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 8px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.textAlign = 'left';
    p.style.margin = '0 0 24px';
    p.style.fontSize = '14px';
    p.style.color = 'rgba(71, 70, 73, 0.7)';
    container.appendChild(p);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  // Restore previous answer (string or {choice, other_text})
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let existingChoice = null;
  let existingOtherText = '';

  if (typeof stored === 'string') {
    existingChoice = stored;
  } else if (stored && typeof stored === 'object') {
    existingChoice = stored.choice;
    existingOtherText = stored.other_text || '';
  }

  const buttonsByValue = {};
  let selectedValue = existingChoice || null;

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) => {
      el.classList.remove('is-selected');
    });
  }

  // "Other" input + wrapper (hidden by default)
  const otherWrapper = document.createElement('div');
  otherWrapper.className = 'quiz-ethnicity-other';
  otherWrapper.style.display = 'none';

  const otherInput = document.createElement('input');
  otherInput.type = 'text';
  otherInput.className = 'quiz-ethnicity-other-input';
  otherInput.placeholder = 'Please specify';

  otherWrapper.appendChild(otherInput);

  const otherError = document.createElement('p');
  otherError.className = 'quiz-ethnicity-other-error';
  otherError.textContent = 'Please tell us a bit more about your ethnicity.';
  otherError.style.display = 'none';
  otherWrapper.appendChild(otherError);

  container.appendChild(otherWrapper);

  // Continue button, only visible for "Other"
  const nextBtn = createButton('Continue');
  nextBtn.style.marginTop = '16px';
  nextBtn.style.display = 'none';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  function validateOther(showErrors) {
    const val = otherInput.value.trim();
    const ok = val.length > 0;

    if (!ok && showErrors) {
      otherWrapper.classList.add('quiz-ethnicity-other--error');
      otherError.style.display = 'block';
    } else {
      otherWrapper.classList.remove('quiz-ethnicity-other--error');
      otherError.style.display = 'none';
    }

    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !ok);

    return ok;
  }

  function handleSelect(value, btn) {
    selectedValue = value;
    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'other') {
      // Show text field + button; do not auto-advance
      otherWrapper.style.display = 'block';
      nextBtn.style.display = 'block';
      otherInput.focus();
      validateOther(false);
    } else {
      // Hide "Other" UI if switching away
      otherWrapper.style.display = 'none';
      otherError.style.display = 'none';
      nextBtn.style.display = 'none';

      // Record simple value and move on
      recordAnswer(step.id, step.text, value);
      goToNextStep();
    }
  }

  // Create option buttons
  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    buttonsByValue[opt.value] = btn;
    optionsWrapper.appendChild(btn);

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
  });

  // Other input interactions
  otherInput.addEventListener('input', () => validateOther(false));
  otherInput.addEventListener('blur', () => validateOther(true));

  nextBtn.addEventListener('click', () => {
    if (!validateOther(true)) return;

    const otherText = otherInput.value.trim();
    recordAnswer(step.id, step.text, {
      choice: 'other',
      other_text: otherText
    });
    goToNextStep();
  });

  // -------- Initial render (when coming back) --------
  if (existingChoice && buttonsByValue[existingChoice]) {
    const btn = buttonsByValue[existingChoice];
    btn.classList.add('is-selected');

    if (existingChoice === 'other') {
      // Restore text + UI without auto-advancing
      otherWrapper.style.display = 'block';
      otherInput.value = existingOtherText || '';
      nextBtn.style.display = 'block';
      validateOther(false);
    }
  }
}



function renderUsingMedicationStep(step, container) {
  // Heading
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || null;
  let selectedValue = existing || null;

  const steps = getSteps();
  const thisIndex = currentStepIndex;
  const whichIndex = steps.findIndex((s) => s.id === 'weight.which_medication');

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected')
    );
  }

  function handleSelect(value, btn) {
    selectedValue = value;
    recordAnswer(step.id, step.text, value);
    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'no') {
      // Skip which_medication if it is the very next step
      if (whichIndex !== -1 && whichIndex === thisIndex + 1) {
        currentStepIndex = thisIndex + 2;   // jump over which_medication
      } else {
        currentStepIndex = thisIndex + 1;
      }
      renderCurrentStep();
scrollQuizToTop();
    } else {
      // yes → go to which_medication (next step)
      goToNextStep();
    }
  }

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    if (selectedValue === opt.value) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
    optionsWrapper.appendChild(btn);
  });
}


function renderWhichMedicationStep(step, container) {
  // Heading
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  // Restore stored value (string or {choice, other_text})
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let existingChoice = null;
  let existingOtherText = '';

  if (typeof stored === 'string') {
    existingChoice = stored;
  } else if (stored && typeof stored === 'object') {
    existingChoice = stored.choice;
    existingOtherText = stored.other_text || '';
  }

  const buttonsByValue = {};
  let selectedValue = existingChoice || null;

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected')
    );
  }

  // Other input + wrapper
  const otherWrapper = document.createElement('div');
  otherWrapper.className = 'quiz-medication-other';
  otherWrapper.style.display = 'none';

  const otherInput = document.createElement('input');
  otherInput.type = 'text';
  otherInput.className = 'quiz-medication-other-input';
  otherInput.placeholder = 'Please specify medication';

  otherWrapper.appendChild(otherInput);

  const otherError = document.createElement('p');
  otherError.className = 'quiz-medication-other-error';
  otherError.textContent = 'Please specify the medication you are taking.';
  otherError.style.display = 'none';
  otherWrapper.appendChild(otherError);

  container.appendChild(otherWrapper);

  // Continue button (only for "Other")
  const nextBtn = createButton('Continue');
  nextBtn.style.marginTop = '16px';
  nextBtn.style.display = 'none';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  function validateOther(showErrors) {
    const val = otherInput.value.trim();
    const ok = val.length > 0;

    if (!ok && showErrors) {
      otherWrapper.classList.add('quiz-medication-other--error');
      otherError.style.display = 'block';
    } else {
      otherWrapper.classList.remove('quiz-medication-other--error');
      otherError.style.display = 'none';
    }

    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !ok);
    return ok;
  }

  function handleSelect(value, btn) {
    selectedValue = value;
    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'other') {
      // Show textbox + Continue; do not auto-advance
      otherWrapper.style.display = 'block';
      nextBtn.style.display = 'block';
      if (!otherInput.value) otherInput.focus();
      validateOther(false);
    } else {
      // Hide "Other" UI and auto-advance
      otherWrapper.style.display = 'none';
      otherError.style.display = 'none';
      nextBtn.style.display = 'none';

      recordAnswer(step.id, step.text, value);
      goToNextStep();
    }
  }

  // Build option buttons
  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    buttonsByValue[opt.value] = btn;
    optionsWrapper.appendChild(btn);

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
  });

  // Input interactions
  otherInput.addEventListener('input', () => validateOther(false));
  otherInput.addEventListener('blur', () => validateOther(true));

  nextBtn.addEventListener('click', () => {
    if (!validateOther(true)) return;
    const text = otherInput.value.trim();
    recordAnswer(step.id, step.text, { choice: 'other', other_text: text });
    goToNextStep();
  });

  // Initial restore
  if (existingChoice && buttonsByValue[existingChoice]) {
    const btn = buttonsByValue[existingChoice];
    btn.classList.add('is-selected');
    if (existingChoice === 'other') {
      otherWrapper.style.display = 'block';
      otherInput.value = existingOtherText || '';
      nextBtn.style.display = 'block';
      validateOther(false);
    }
  }
}



function renderOtherConditionsStep(step, container) {
  // Heading + subtext
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 4px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.textAlign = 'left';
    p.style.margin = '0 0 16px';
    p.style.fontSize = '14px';
    p.style.color = 'rgba(71, 70, 73, 0.7)';
    container.appendChild(p);
  }

  // Restore previous selection (array of values)
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const selected = new Set(Array.isArray(stored) ? stored : []);

  // Wrapper + scroll area
  const wrapper = document.createElement('div');
  wrapper.className = 'quiz-conditions-wrapper';

  const scrollBox = document.createElement('div');
  scrollBox.className = 'quiz-conditions-scroll';
  wrapper.appendChild(scrollBox);

  const CHECK_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-conditions-check-icon">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  `;

  const rowsByValue = {};

  step.options.forEach((opt) => {
    const row = document.createElement('button');
    row.type = 'button';
    row.className = 'quiz-reasons-option quiz-conditions-row';
    row.dataset.value = opt.value;

    row.innerHTML = `
      <span class="quiz-conditions-label">${opt.label}</span>
      <span class="quiz-conditions-checkbox">
        ${CHECK_SVG}
      </span>
    `;

    rowsByValue[opt.value] = row;
    scrollBox.appendChild(row);

    row.addEventListener('click', () => {
      const v = opt.value;
      if (selected.has(v)) selected.delete(v);
      else selected.add(v);
      refreshState(false);
    });
  });

  container.appendChild(wrapper);

  // Scroll toggle button
  const toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'quiz-conditions-toggle';
  toggleBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-conditions-toggle-icon">
      <path d="m6 9 6 6 6-6"></path>
    </svg>
  `;
  container.appendChild(toggleBtn);

  // Error card
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  // Next button
  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    recordAnswer(step.id, step.text, Array.from(selected));
    goToNextStep();
  });

  // ---- Behaviour helpers ----

  function refreshState(showErrors) {
    // Update selected classes
    Object.keys(rowsByValue).forEach((value) => {
      const row = rowsByValue[value];
      row.classList.toggle('is-selected', selected.has(value));
    });

    const values = Array.from(selected);
    const hasAny = values.length > 0;
    const hasNonNone = values.some((v) => v !== 'none_of_the_above');

    const showError = hasAny && hasNonNone;
    errorBox.style.display = showError ? 'flex' : 'none';

    const canContinue = hasAny && !hasNonNone; // only "None of the above" selected
    nextBtn.disabled = !canContinue;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !canContinue);

    if (showErrors && !canContinue && hasAny) {
      // could add extra visual cue if desired
    }

    // Store current selection
    if (hasAny) {
      recordAnswer(step.id, step.text, values);
    }
  }

  // Scroll behaviour for toggle arrow
  function updateToggleState() {
    const atTop = scrollBox.scrollTop <= 0;
    toggleBtn.classList.toggle('quiz-conditions-toggle--up', !atTop);
  }

  scrollBox.addEventListener('scroll', updateToggleState);

  toggleBtn.addEventListener('click', () => {
    const atTop = scrollBox.scrollTop <= 0;
    const targetTop = atTop ? scrollBox.scrollHeight : 0;
    scrollBox.scrollTo({ top: targetTop, behavior: 'smooth' });
  });

  // Initial state
  refreshState(false);
  updateToggleState();
}



function renderEatingDisorderStep(step, container) {
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || null;
  let selectedValue = existing || null;

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected', 'quiz-situation-option--danger')
    );
  }

  // Error card
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  function handleSelect(value, btn) {
    selectedValue = value;
    recordAnswer(step.id, step.text, value);
    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'yes') {
      // show red card + red option
      btn.classList.add('quiz-situation-option--danger');
      errorBox.style.display = 'flex';
      return; // user cannot proceed
    }

    // value === 'no' → go next
    errorBox.style.display = 'none';
    goToNextStep();
  }

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;
    optionsWrapper.appendChild(btn);

    if (selectedValue === opt.value) {
      btn.classList.add('is-selected');
      if (opt.value === 'yes') {
        btn.classList.add('quiz-situation-option--danger');
        errorBox.style.display = 'flex';
      }
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
  });
}

function renderOtherMedicalStep(step, container) {
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  // Restore stored ({choice, details}) or simple "no"
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let existingChoice = null;
  let existingDetails = '';

  if (typeof stored === 'string') {
    existingChoice = stored;
  } else if (stored && typeof stored === 'object') {
    existingChoice = stored.choice;
    existingDetails = stored.details || '';
  }

  let selectedValue = existingChoice || null;

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected')
    );
  }

  // "Please specify" input + Next (reuse medication-other styles)
  const otherWrapper = document.createElement('div');
  otherWrapper.className = 'quiz-medication-other';
  otherWrapper.style.display = 'none';

  const otherInput = document.createElement('input');
  otherInput.type = 'text';
  otherInput.className = 'quiz-medication-other-input';
  otherInput.placeholder = 'Please specify';
  otherWrapper.appendChild(otherInput);

  const otherError = document.createElement('p');
  otherError.className = 'quiz-medication-other-error';
  otherError.textContent = 'Please tell us a bit more about your condition.';
  otherError.style.display = 'none';
  otherWrapper.appendChild(otherError);

  container.appendChild(otherWrapper);

  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.style.display = 'none';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  function validateOther(showErrors) {
    const val = otherInput.value.trim();
    const ok = val.length > 0;

    if (!ok && showErrors) {
      otherWrapper.classList.add('quiz-medication-other--error');
      otherError.style.display = 'block';
    } else {
      otherWrapper.classList.remove('quiz-medication-other--error');
      otherError.style.display = 'none';
    }

    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !ok);
    return ok;
  }

  function handleSelect(value, btn) {
    clearSelections();
    btn.classList.add('is-selected');
    selectedValue = value;

    if (value === 'no') {
      // straight to next step
      recordAnswer(step.id, step.text, 'no');
      goToNextStep();
      return;
    }

    // value === 'yes' → show textbox + Next
    otherWrapper.style.display = 'block';
    nextBtn.style.display = 'block';
    validateOther(false);

    if (existingDetails) {
      otherInput.value = existingDetails;
      validateOther(false);
    } else {
      otherInput.focus();
    }
  }

  // Build Yes/No options
  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;
    optionsWrapper.appendChild(btn);

    if (selectedValue === opt.value) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
  });

  otherInput.addEventListener('input', () => validateOther(false));
  otherInput.addEventListener('blur', () => validateOther(true));

  nextBtn.addEventListener('click', () => {
    if (!validateOther(true)) return;
    const text = otherInput.value.trim();
    recordAnswer(step.id, step.text, { choice: 'yes', details: text });
    goToNextStep();
  });

  // Initial restore
  if (existingChoice === 'yes') {
    const yesBtn = optionsWrapper.querySelector('[data-value="yes"]');
    if (yesBtn) {
      yesBtn.classList.add('is-selected');
      otherWrapper.style.display = 'block';
      nextBtn.style.display = 'block';
      otherInput.value = existingDetails || '';
      validateOther(false);
    }
  }
}

function renderRegularMedsStep(step, container) {
  // Heading + subtext
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 4px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.textAlign = 'left';
    p.style.margin = '0 0 16px';
    p.style.fontSize = '14px';
    p.style.color = 'rgba(71, 70, 73, 0.7)';
    container.appendChild(p);
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'quiz-conditions-wrapper';
  const scrollBox = document.createElement('div');
  scrollBox.className = 'quiz-conditions-scroll';
  wrapper.appendChild(scrollBox);
  container.appendChild(wrapper);

  // Restore previous selection
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const selected = new Set(Array.isArray(stored) ? stored : []);

  const rowsByValue = {};
  const HIGH_RISK = new Set(['metformin', 'sglt2', 'insulin', 'sulfonylureas']);

  const CHECK_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-conditions-check-icon">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  `;

  step.options.forEach((opt) => {
    const row = document.createElement('button');
    row.type = 'button';
    row.className = 'quiz-reasons-option quiz-conditions-row';
    row.dataset.value = opt.value;

    row.innerHTML = `
      <span class="quiz-conditions-label">${opt.label}</span>
      <span class="quiz-conditions-checkbox">${CHECK_SVG}</span>
    `;

    rowsByValue[opt.value] = row;
    scrollBox.appendChild(row);

    row.addEventListener('click', () => {
      const v = opt.value;
      if (selected.has(v)) selected.delete(v);
      else selected.add(v);
      refreshState(false);
    });
  });

  // Scroll toggle
  const toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'quiz-conditions-toggle';
  toggleBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" class="quiz-conditions-toggle-icon">
      <path d="m6 9 6 6 6-6"></path>
    </svg>
  `;
  container.appendChild(toggleBtn);

  // Error card
  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-reasons-error';
  errorBox.innerHTML = `
    <div class="quiz-reasons-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-reasons-error__body">
      <p class="quiz-reasons-error__title">Important Safety Information</p>
      <p class="quiz-reasons-error__text">
        Based on your answer, we cannot offer you medication for this condition.
      </p>
    </div>
  `;
  errorBox.style.display = 'none';
  container.appendChild(errorBox);

  // Next button
  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    recordAnswer(step.id, step.text, Array.from(selected));
    goToNextStep();
  });

  function refreshState(showErrors) {
    Object.keys(rowsByValue).forEach((value) => {
      const row = rowsByValue[value];
      row.classList.toggle('is-selected', selected.has(value));
    });

    const values = Array.from(selected);
    const hasAny = values.length > 0;
    const hasHighRisk = values.some((v) => HIGH_RISK.has(v));

    const showError = hasAny && hasHighRisk;
    errorBox.style.display = showError ? 'flex' : 'none';

    const canContinue = hasAny && !hasHighRisk;
    nextBtn.disabled = !canContinue;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !canContinue);

    if (hasAny) {
      recordAnswer(step.id, step.text, values);
    }
  }

  function updateToggleState() {
    const atTop = scrollBox.scrollTop <= 0;
    toggleBtn.classList.toggle('quiz-conditions-toggle--up', !atTop);
  }

  scrollBox.addEventListener('scroll', updateToggleState);
  toggleBtn.addEventListener('click', () => {
    const atTop = scrollBox.scrollTop <= 0;
    const targetTop = atTop ? scrollBox.scrollHeight : 0;
    scrollBox.scrollTo({ top: targetTop, behavior: 'smooth' });
  });

  // Initial
  refreshState(false);
  updateToggleState();
}



function renderAllergiesStep(step, container) {
  // Heading
  if (step.text) {
    const h = document.createElement('h2');
    h.textContent = step.text;
    h.style.textAlign = 'left';
    h.style.margin = '0 0 24px';
    h.style.lineHeight = '1.3';
    container.appendChild(h);
  }

  const optionsWrapper = document.createElement('div');
  optionsWrapper.className = 'quiz-reasons-options';
  container.appendChild(optionsWrapper);

  // Restore stored value (string or {choice, details})
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let existingChoice = null;
  let existingDetails = '';

  if (typeof stored === 'string') {
    existingChoice = stored;
  } else if (stored && typeof stored === 'object') {
    existingChoice = stored.choice;
    existingDetails = stored.details || '';
  }

  let selectedValue = existingChoice || null;

  function clearSelections() {
    optionsWrapper.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected')
    );
  }

  // "Please specify" + Next
  const otherWrapper = document.createElement('div');
  otherWrapper.className = 'quiz-medication-other';
  otherWrapper.style.display = 'none';

  const otherInput = document.createElement('input');
  otherInput.type = 'text';
  otherInput.className = 'quiz-medication-other-input';
  otherInput.placeholder = 'Please specify';
  otherWrapper.appendChild(otherInput);

  const otherError = document.createElement('p');
  otherError.className = 'quiz-medication-other-error';
  otherError.textContent = 'Please tell us more about your allergy.';
  otherError.style.display = 'none';
  otherWrapper.appendChild(otherError);

  container.appendChild(otherWrapper);

  const nextBtn = createButton('Next');
  nextBtn.style.marginTop = '16px';
  nextBtn.style.display = 'none';
  nextBtn.disabled = true;
  nextBtn.classList.add('xo-quiz-button--disabled');
  container.appendChild(nextBtn);

  function validateOther(showErrors) {
    const val = otherInput.value.trim();
    const ok = val.length > 0;

    if (!ok && showErrors) {
      otherWrapper.classList.add('quiz-medication-other--error');
      otherError.style.display = 'block';
    } else {
      otherWrapper.classList.remove('quiz-medication-other--error');
      otherError.style.display = 'none';
    }

    nextBtn.disabled = !ok;
    nextBtn.classList.toggle('xo-quiz-button--disabled', !ok);
    return ok;
  }

  function handleSelect(value, btn) {
    clearSelections();
    btn.classList.add('is-selected');
    selectedValue = value;

    if (value === 'no') {
      // straight to next step
      recordAnswer(step.id, step.text, 'no');
      goToNextStep();
      return;
    }

    // value === 'yes' → show textbox + Next
    otherWrapper.style.display = 'block';
    nextBtn.style.display = 'block';

    if (existingDetails) {
      otherInput.value = existingDetails;
    }
    validateOther(false);
    if (!existingDetails) otherInput.focus();
  }

  // Build Yes/No options
  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    if (selectedValue === opt.value) {
      btn.classList.add('is-selected');
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
    optionsWrapper.appendChild(btn);
  });

  otherInput.addEventListener('input', () => validateOther(false));
  otherInput.addEventListener('blur', () => validateOther(true));

  nextBtn.addEventListener('click', () => {
    if (!validateOther(true)) return;
    const text = otherInput.value.trim();
    recordAnswer(step.id, step.text, { choice: 'yes', details: text });
    goToNextStep();
  });

  // Initial restore
  if (existingChoice === 'yes') {
    const yesBtn = optionsWrapper.querySelector('[data-value="yes"]');
    if (yesBtn) {
      yesBtn.classList.add('is-selected');
      otherWrapper.style.display = 'block';
      nextBtn.style.display = 'block';
      otherInput.value = existingDetails || '';
      validateOther(false);
    }
  }
}



function renderGpDetailsStep(step, container) {
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const existing = (stored && typeof stored === 'object')
    ? stored
    : {
        mode: 'search',
        search_postcode: '',
        manual: { practice: '', address1: '', city: '', postcode: '', odsCode: '' }
      };

  GP_DETAILS_MODE = existing.mode || 'search';

  container.innerHTML = `
    <div class="gpCard">
      <h2 class="gpCard__title">${escapeHtml(step.text || "Can you share your GP’s details?")}</h2>
      <p class="gpCard__sub">${escapeHtml(step.subtext || "Search for your GP by entering your postcode.")}</p>

      <div class="gpCard__search" data-gp-search>
        <input class="gpCard__postcode" type="text" placeholder="Postcode"
               value="${escapeHtml(existing.search_postcode || '')}">
        <button class="gpCard__find" type="button">Find</button>
      </div>

      <div class="gpCard__loading" data-gp-loading style="display:none;">
        <div class="gpCard__spinner"></div>
        <span>Searching practices...</span>
      </div>

      <div class="gpCard__results" data-gp-results></div>

      <p class="gpCard__noResults" data-gp-noresults style="display:none;">
        No GP practices found for that postcode. You can add your GP manually.
      </p>

      <div class="gpCard__manual" data-gp-manual style="display:none;">
        <input class="gpCard__input" data-field="practice" type="text"
               placeholder="GP Practice Name"
               value="${escapeHtml(existing.manual?.practice || '')}">
        <input class="gpCard__input" data-field="address1" type="text"
               placeholder="Address Line 1"
               value="${escapeHtml(existing.manual?.address1 || '')}">
        <input class="gpCard__input" data-field="city" type="text"
               placeholder="City"
               value="${escapeHtml(existing.manual?.city || '')}">
        <input class="gpCard__input" data-field="postcode" type="text"
               placeholder="Postcode"
               value="${escapeHtml(existing.manual?.postcode || '')}">
        <button class="gpCard__back" type="button">Back to Search</button>
      </div>

      <div class="gpCard__manualBar" data-gp-manualbar>
        <button class="gpCard__manualLink" type="button">+ Manual Add</button>
      </div>

      <div class="gpCard__info">
        <h4 class="gpCard__infoTitle">Why we ask</h4>
        <p class="gpCard__infoText">
          In order to ensure safe quality care, we need to confirm your GP’s details so we can let them
          know about your treatment. By providing this, you consent for this information to be shared
          with their office.
        </p>
      </div>
    </div>
  `;

  const postcodeInput = container.querySelector('.gpCard__postcode');
  const findBtn = container.querySelector('.gpCard__find');
  const noResults = container.querySelector('[data-gp-noresults]');
  const resultsBox = container.querySelector('[data-gp-results]');
  const loadingBox = container.querySelector('[data-gp-loading]');

  const manual = container.querySelector('[data-gp-manual]');
  const manualInputs = container.querySelectorAll('.gpCard__input');
  const backBtn = container.querySelector('.gpCard__back');

  const manualBar = container.querySelector('[data-gp-manualbar]');
  const manualLink = container.querySelector('.gpCard__manualLink');

  const manualPracticeInput = manual.querySelector('[data-field="practice"]');
const manualAddressInput  = manual.querySelector('[data-field="address1"]');
const manualCityInput     = manual.querySelector('[data-field="city"]');
const manualPostcodeInput = manual.querySelector('[data-field="postcode"]');

  const confirmBtn = createButton('Confirm');
  confirmBtn.style.display = 'block';
  confirmBtn.style.margin = '24px auto 0';
  confirmBtn.disabled = true;
  confirmBtn.style.opacity = '0.55';
  container.appendChild(confirmBtn);

  function save() {
    recordAnswer(step.id, step.text, existing);
  }

  function validateManual(showErrors) {
    const vals = {};
    let ok = true;

    manualInputs.forEach((inp) => {
      const key = inp.dataset.field;
      const v = inp.value.trim();
      vals[key] = v;
      if (!v) ok = false;
      if (showErrors && !v) inp.classList.add('gpCard__input--error');
      else inp.classList.remove('gpCard__input--error');
    });

    vals.odsCode = existing.manual?.odsCode || '';
    existing.manual = vals;

    confirmBtn.disabled = !ok;
    confirmBtn.style.opacity = ok ? '1' : '0.55';

    save();
    return ok;
  }

  function setMode(mode) {
    GP_DETAILS_MODE = mode;
    existing.mode = mode;

    if (mode === 'search') {
      manual.style.display = 'none';
      manualBar.style.display = 'flex';
      resultsBox.style.display = 'block';
      noResults.style.display = 'none';
      confirmBtn.disabled = true;
      confirmBtn.style.opacity = '0.55';
    } else {
  manual.style.display = 'block';
  manualBar.style.display = 'none';
  resultsBox.style.display = 'none';
  noResults.style.display = 'none';
  // DO NOT validate here; we will validate after filling fields
}

    save();
  }

  async function performSearch(pc) {
    noResults.style.display = 'none';
    resultsBox.innerHTML = '';

    if (loadingBox) loadingBox.style.display = 'flex';

    const trimmed = pc.trim();
    existing.search_postcode = trimmed;
    save();

    if (!trimmed) {
      if (loadingBox) loadingBox.style.display = 'none';
      postcodeInput.focus();
      return;
    }

    const originalLabel = findBtn.textContent;
    findBtn.disabled = true;
    findBtn.textContent = 'Searching...';

try {
  const requestUrl =
    `${QUIZ_ENDPOINT}?action=ods_search&postcode=${encodeURIComponent(trimmed)}`;

  const res = await fetch(requestUrl, { method: 'GET' });

  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    throw new Error('Server did not return JSON: ' + text.slice(0, 200));
  }

  if (!res.ok || !data.ok) {
    throw new Error(data && data.error ? data.error : `HTTP ${res.status}`);
  }

  const items = Array.isArray(data.items) ? data.items : [];

  if (!items.length) {
    noResults.textContent = 'No GP practices found for that postcode. You can add your GP manually.';
    noResults.style.display = 'block';
    return;
  }

  // ... keep your existing items.forEach(...) block exactly as-is ...
  items.forEach((item) => {
    const name = item.name || item.Name || 'Practice';
    const address1 = item.address1 || item.Address1 || item.AddressLine1 || item.address || '';
    const city = item.city || item.City || item.town || item.Town || '';
    const postcode = item.postcode || item.PostCode || item.postCode || '';

    const line = [address1, city, postcode].filter(Boolean).join(', ');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gpResult';
    btn.innerHTML =
      `<div class="gpResult__name">${escapeHtml(name)}</div>` +
      (line ? `<div class="gpResult__meta">${escapeHtml(line)}</div>` : '');

    btn.addEventListener('click', () => {
      existing.mode = 'manual';
      existing.manual = {
        practice: name,
        address1: address1,
        city: city,
        postcode: postcode,
        odsCode: item.odsCode || item.OdsCode || ''
      };

      setMode('manual');

      requestAnimationFrame(() => {
        if (manualPracticeInput) manualPracticeInput.value = existing.manual.practice || '';
        if (manualAddressInput)  manualAddressInput.value  = existing.manual.address1 || '';
        if (manualCityInput)     manualCityInput.value     = existing.manual.city || '';
        if (manualPostcodeInput) manualPostcodeInput.value = existing.manual.postcode || '';
        validateManual(false);
        save();
      });
    });

    resultsBox.appendChild(btn);
  });
} catch (err) {
  console.error('ODS search failed', err);
  noResults.textContent =
    'Sorry, something went wrong searching. ' + (err && err.message ? err.message : '');
  noResults.style.display = 'block';
} finally {
      findBtn.disabled = false;
      findBtn.textContent = originalLabel;
      if (loadingBox) loadingBox.style.display = 'none';
    }
  }

  // Events
  postcodeInput.addEventListener('input', () => {
    existing.search_postcode = postcodeInput.value.trim();
    noResults.style.display = 'none';
    save();
  });

  postcodeInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performSearch(postcodeInput.value);
    }
  });

  findBtn.addEventListener('click', () => performSearch(postcodeInput.value));

  manualInputs.forEach((inp) => inp.addEventListener('input', () => validateManual(false)));
  manualInputs.forEach((inp) => inp.addEventListener('blur', () => validateManual(true)));

  manualLink.addEventListener('click', () => setMode('manual'));
  backBtn.addEventListener('click', () => setMode('search'));

  confirmBtn.addEventListener('click', () => {
    if (GP_DETAILS_MODE !== 'manual') return;
    if (!validateManual(true)) return;
    goToNextStep();
  });

  setMode(existing.mode || 'search');
}

function renderDobConfirmStep(step, container) {
  // Heading
  const title = document.createElement('h2');
  title.className = 'quiz-dob__title';
  title.textContent = step.text || 'One final thing...';
  container.appendChild(title);

  // Card
  const card = document.createElement('div');
  card.className = 'quiz-dob-card';
  card.innerHTML = `
    <p class="quiz-dob-card__text">
      I confirm that any medication prescribed is for my personal use only, that my answers to all
      questions are honest and truthful, and that I understand and will inform myself of the
      treatment’s risks, benefits, and alternatives.
    </p>
    <label class="quiz-dob-card__label">Date of Birth</label>
    <div class="quiz-dob-input-wrap">
      <input type="text" class="quiz-dob-input" placeholder="dd/mm/yyyy">
    </div>
    <p class="quiz-dob-card__helper">
      By entering your date of birth, you confirm the above statement.
    </p>
  `;
  container.appendChild(card);

  // IMPORTANT: we only query inside this card
  const inputWrap = card.querySelector('.quiz-dob-input-wrap');
  const input = card.querySelector('.quiz-dob-input');

  // Restore existing value if user comes back
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  if (stored) input.value = stored;

  // Continue button
  const btn = createButton('Continue');
  btn.disabled = true;
  btn.classList.add('xo-quiz-button--disabled');
  container.appendChild(btn);

  function formatDob(raw) {
    // keep only digits, max 8
    const digits = raw.replace(/\D/g, '').slice(0, 8);
    if (!digits) return '';

    if (digits.length <= 2) {
      // d or dd
      return digits;
    } else if (digits.length <= 4) {
      // ddm or ddmm
      return digits.slice(0, 2) + '/' + digits.slice(2);
    } else {
      // ddmmY, ddmmYY, ddmmYYYY
      return (
        digits.slice(0, 2) +
        '/' +
        digits.slice(2, 4) +
        '/' +
        digits.slice(4)
      );
    }
  }

  function isValidDob(val) {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(val);
    if (!m) return false;
    const day = parseInt(m[1], 10);
    const month = parseInt(m[2], 10);
    const year = parseInt(m[3], 10);
    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
    const nowYear = new Date().getFullYear();
    if (year < 1900 || year > nowYear) return false;
    return true;
  }

 function updateState(showErrors) {
  const val = input.value.trim();
  const okFormat = isValidDob(val);

  // compute age if format ok
  let under18 = false;

  if (okFormat) {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(val);
    const day = +m[1];
    const month = +m[2];
    const year = +m[3];

    const today = new Date();
    const birthDate = new Date(year, month - 1, day);

    let age = today.getFullYear() - birthDate.getFullYear();
    const mDiff = today.getMonth() - birthDate.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    under18 = age < 18;
  }

  // input error styling: invalid format OR under 18
  if ((showErrors && !okFormat) || under18) {
    inputWrap.classList.add('quiz-dob-input-wrap--error');
  } else {
    inputWrap.classList.remove('quiz-dob-input-wrap--error');
  }

  // show/hide underage error message
  let ageError = card.querySelector('[data-dob-age-error]');
  if (!ageError) {
    ageError = document.createElement('div');
    ageError.setAttribute('data-dob-age-error', 'true');
    ageError.className = 'quiz-hw-error';
    ageError.style.display = 'none';
    ageError.innerHTML = `
      <div class="quiz-hw-error__icon">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             aria-hidden="true">
          <circle cx="8" cy="21" r="1"></circle>
          <circle cx="19" cy="21" r="1"></circle>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
        </svg>
      </div>
      <div class="quiz-hw-error__text">You must be at least 18 years old to continue.</div>
    `;
    card.appendChild(ageError);
  }

  ageError.style.display = under18 ? 'flex' : 'none';

  // enable only if valid AND not under 18
  const canContinue = okFormat && !under18;
  btn.disabled = !canContinue;
  btn.classList.toggle('xo-quiz-button--disabled', !canContinue);

  if (val) recordAnswer(step.id, 'Date of Birth', val);
}

  // Only this one input is masked
  input.addEventListener('input', () => {
    const formatted = formatDob(input.value);
    input.value = formatted;
    updateState(false);
  });

  input.addEventListener('blur', () => updateState(true));

  btn.addEventListener('click', () => {
    updateState(true);
    if (btn.disabled) return;
    const val = input.value.trim();
    recordAnswer(step.id, 'Date of Birth', val);
    goToNextStep();
  });

  // Initial
  updateState(false);
}
let resultScrollCleanup = null;

function parseMonthlyPrice(priceText) {
  const match = String(priceText).match(/([\d.,]+)/);
  return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
}
function formatMonthlyPrice(amount) {
  return '£' + Number(amount || 0).toFixed(2) + '/month';
}

function renderTreatmentResult(selectedId = 'mounjaro') {
  setProgressPercent(100);

  if (resultScrollCleanup) {
    resultScrollCleanup();
    resultScrollCleanup = null;
  }

  const product = TREATMENT_PRODUCTS[selectedId] || TREATMENT_PRODUCTS.mounjaro;
  const others = Object.values(TREATMENT_PRODUCTS).filter((p) => p.id !== product.id);

  const metrics = typeof computeJourneyMetrics === 'function'
  ? computeJourneyMetrics(product.id)
  : null;
  const currentKg = metrics && metrics.weightKg ? Math.round(metrics.weightKg) : 70;
  const lossKg = metrics && metrics.lossKg ? metrics.lossKg.toFixed(1) : '15.8';

  // Using medication logic
  const usingAnswer = QUIZ_ANSWERS['weight.using_medication'];
  const isOnMeds = usingAnswer && usingAnswer.value === 'yes';

  const allStrengths = product.strengths || [];
  const visibleStrengths = isOnMeds ? allStrengths : allStrengths.filter((s) => s.isStarting);

  let selectedStrengthId =
    product.startingStrengthId ||
    (product.strengths && product.strengths.find((s) => s.isStarting)?.id) ||
    (product.strengths && product.strengths[0]?.id) ||
    null;

  const getSelectedStrength = () =>
    (product.strengths || []).find((s) => s.id === selectedStrengthId) || null;

  root.innerHTML = '';

  const wrap = document.createElement('div');
  wrap.className = 'quiz-result';

function renderTag(tag) {
  const label = (tag.label || '').trim();

  if (/most effective/i.test(label)) {
    return `
      <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
        <span class="quiz-result__tagIconCircle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </span>
        <span class="quiz-result__tagText">${label}</span>
      </span>
    `;
  }

  // ✅ NEW: add tick icon for "Cost effective"
  if (/cost effective/i.test(label)) {
    return `
      <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
        <span class="quiz-result__tagIconCircle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </span>
        <span class="quiz-result__tagText">${label}</span>
      </span>
    `;
  }

  if (/in stock/i.test(label)) {
    return `
      <span class="quiz-result__tag quiz-result__tag--${tag.variant} quiz-result__tag--in-stock">
        <span class="quiz-result__tagIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <circle cx="8" cy="21" r="1"></circle>
            <circle cx="19" cy="21" r="1"></circle>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
          </svg>
        </span>
        <span class="quiz-result__tagText">${label}</span>
      </span>
    `;
  }

  return `
    <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
      <span class="quiz-result__tagText">${label}</span>
    </span>
  `;
}
function getStartingStrengthPriceText(p) {
  const strengths = p.strengths || [];
  const starting =
    strengths.find(s => s.id === p.startingStrengthId) ||
    strengths.find(s => s.isStarting) ||
    strengths[0];

  return starting?.priceText || p.price;
}
  wrap.innerHTML = `
    <div class="quiz-result__hero">
      <p class="quiz-result__subtitle">A clinician may consider this match for you:</p>

      <div class="quiz-result__tags ${product.tags.length === 1 ? 'quiz-result__tags--single' : ''}">
        ${product.tags.map(renderTag).join('')}
      </div>

      <h2 class="quiz-result__title">${product.nameHtml}</h2>

    <div class="quiz-result__image">
  <img class="quiz-result__hero-img"
       src="${product.image}"
       alt="${product.nameHtml.replace(/<[^>]+>/g, '')}">
</div>

      <div class="quiz-result__stats">
        <div class="quiz-result__stat">
          <p class="quiz-result__stat-label">Your weight profile</p>
          <p class="quiz-result__stat-value">${currentKg} kg</p>
        </div>

        <div class="quiz-result__stat">
          <p class="quiz-result__stat-label">Potential weight loss</p>
          <p class="quiz-result__stat-value">${lossKg} kg</p>
        </div>
      </div>

      <div class="quiz-result__strengths">
        <div class="quiz-result__strengths-header">
          <p class="quiz-result__strengths-label">Select strength</p>
          <span class="quiz-result__strengths-pill" data-starting-pill>Starting strength</span>
        </div>

        <div class="quiz-result__selectShell" data-strength-trigger>
          <span class="quiz-result__selectValue" data-strength-display>
            ${
              (
                visibleStrengths.find((s) => s.id === selectedStrengthId) ||
                visibleStrengths[0] ||
                {}
              ).label?.split('–')[0]?.trim() || ''
            }
          </span>
          <span class="quiz-result__selectArrow">▾</span>
        </div>
      </div>

      <div class="quiz-strength-modal" aria-hidden="true">
        <div class="quiz-strength-modal__backdrop"></div>
        <div class="quiz-strength-modal__dialog" role="dialog" aria-modal="true">
          ${visibleStrengths
            .map(
              (s) => `
              <button
                type="button"
                class="quiz-strength-modal__option ${s.id === selectedStrengthId ? 'is-selected' : ''}"
                data-strength-id="${s.id}"
              >
                <span class="quiz-strength-modal__check">✓</span>
                <span class="quiz-strength-modal__label">${s.label.split('–')[0].trim()}</span>
              </button>
            `
            )
            .join('')}
        </div>
      </div>

      <div class="quiz-result__bottom">
        <p class="quiz-result__small-copy">${product.doseCopy}</p>
        <p class="quiz-result__price">${product.price}</p>

        <button class="xo-quiz-button quiz-result__primary-cta" type="button" data-result-primary>
          <span>Continue with this plan</span>
        </button>
      </div>

      <button class="quiz-result__secondary-cta" type="button" data-result-other>
        Explore other treatment options
      </button>
    </div>

    <div class="quiz-accordion">
      ${product.accordions
        .map(
          (acc, idx) => `
          <div class="quiz-accordion__item" data-acc-index="${idx}">
            <button class="quiz-accordion__header" type="button">
              <span>${acc.title}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="quiz-accordion__icon" aria-hidden="true">
                <path d="m6 9 6 6 6-6"></path>
              </svg>
            </button>
            <div class="quiz-accordion__content">
              <p>${acc.content}</p>
            </div>
          </div>`
        )
        .join('')}
    </div>

    <p class="quiz-result__footer-note">
      A clinician will review all of your responses to determine if this treatment option is a good fit.
    </p>

    <div class="quiz-result-modal" aria-hidden="true">
      <div class="quiz-result-modal__backdrop"></div>
      <div class="quiz-result-modal__dialog" role="dialog" aria-modal="true">
        <div class="quiz-result-modal__header">
          <h3 class="quiz-result-modal__title">Other treatment options</h3>
          <button type="button" class="quiz-result-modal__close" data-modal-close>&times;</button>
        </div>
        <p class="quiz-result-modal__subtitle">Based on your profile, here are other options available.</p>

        <div class="quiz-result-modal__options">
          ${others
            .map(
              (p) => `
<div class="quiz-result-modal__option" data-product-id="${p.id}">
                <div class="quiz-result-modal__option-main">
                  <div class="quiz-result-modal__text">
                    <p class="quiz-result-modal__option-name">${p.nameHtml}</p>
                    <p class="quiz-result-modal__option-sub">${
                      p.id === 'mounjaro' ? 'Tirzepatide' : p.id === 'wegovy' ? 'Semaglutide' : 'Orlistat'
                    }</p>
                  </div>

                  <img class="quiz-result-modal__image"
                       src="${p.modalImage || p.image}"
                       alt="${p.nameHtml.replace(/<[^>]+>/g, '')}"
                       loading="lazy" />

<span class="quiz-result-modal__pill">${getStartingStrengthPriceText(p)}</span>
                </div>

                <button type="button" class="xo-quiz-button quiz-result-modal__select">
                  <span>Select</span>
                </button>
              </div>`
            )
            .join('')}
        </div>
      </div>
    </div>
  `;

  root.appendChild(wrap);

  // insert this after root.appendChild(wrap);
(function injectQuizImageStyles() {
  if (document.getElementById('xo-quiz-image-styles')) return;
  const s = document.createElement('style');
  s.id = 'xo-quiz-image-styles';
s.textContent = `
  /* Main hero image — overflows the card horizontally */
  .quiz-result__image {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    overflow: visible;     /* let image bleed out */
    position: relative;
    z-index: 1;
  }
  .quiz-result__hero-img {
    width: 130%;           /* wider than the card — adjust % to taste */
    max-width: none;       /* remove cap so it actually overflows */
    height: auto;
    display: block;
    background: transparent;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    .quiz-result__hero-img { width: 120%; }
  }

  /* Other-treatments modal thumbnails stay small */
  .quiz-result-modal__image,
  .quiz-result-modal__option .quiz-result-modal__image {
    max-width: 120px;
    width: auto;
    height: auto;
    display: block;
    background: transparent;
  }
`;
  document.head.appendChild(s);
})();

  // Update price + image when strength changes
  const heroImgEl = root.querySelector('.quiz-result__hero-img');
  const priceEl = root.querySelector('.quiz-result__price');

  function updateStrengthUI() {
    const strength = getSelectedStrength();
    if (!strength) return;

    if (priceEl) {
      // Use strength priceText if present, fallback
      const baseText = strength.priceText || product.price;
      const baseVal = parseMonthlyPrice(baseText);
      priceEl.textContent = formatMonthlyPrice(baseVal);
    }

    if (heroImgEl) {
      heroImgEl.src = strength.heroImage || product.image;
    }

    const startingPill = root.querySelector('[data-starting-pill]');
    if (startingPill) {
      const showPill =
        (product.id === 'mounjaro' && strength.id === 'mounjaro-2-5') ||
        (product.id === 'wegovy' && strength.id === 'wegovy-0-25');
      startingPill.style.display = showPill ? '' : 'none';
    }
  }

  updateStrengthUI();

  // Sticky bottom hide near footer (mobile)
  const stickyBottom = root.querySelector('.quiz-result__bottom');
  if (stickyBottom) {
    const footer = document.querySelector('footer') || document.querySelector('.site-footer');

    function handleScroll() {
      if (window.innerWidth > 768) {
        stickyBottom.classList.remove('quiz-result__bottom--hidden');
        return;
      }
      if (!footer) return;

      const footerRect = footer.getBoundingClientRect();
      const nearFooter = footerRect.top < window.innerHeight;
      stickyBottom.classList.toggle('quiz-result__bottom--hidden', nearFooter);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    resultScrollCleanup = () => window.removeEventListener('scroll', handleScroll);
  }

  // Strength modal wiring
  const strengthDisplay = root.querySelector('[data-strength-display]');
  const strengthTrigger = root.querySelector('[data-strength-trigger]');
  const strengthModal = root.querySelector('.quiz-strength-modal');
  const strengthBackdrop = root.querySelector('.quiz-strength-modal__backdrop');
  const strengthButtons = root.querySelectorAll('.quiz-strength-modal__option');

  function openStrengthModal() {
    if (!strengthModal) return;
    strengthModal.classList.add('quiz-strength-modal--open');
    strengthModal.setAttribute('aria-hidden', 'false');
  }
  function closeStrengthModal() {
    if (!strengthModal) return;
    strengthModal.classList.remove('quiz-strength-modal--open');
    strengthModal.setAttribute('aria-hidden', 'true');
  }

  if (strengthTrigger) strengthTrigger.addEventListener('click', (e) => { e.preventDefault(); openStrengthModal(); });
  if (strengthBackdrop) strengthBackdrop.addEventListener('click', closeStrengthModal);

  strengthButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-strength-id');
      if (!id) return;

      selectedStrengthId = id;

      strengthButtons.forEach((b) => b.classList.toggle('is-selected', b === btn));

      const strength = getSelectedStrength();
      if (strength && strengthDisplay) {
        strengthDisplay.textContent = strength.label.split('–')[0].trim();
      }

      updateStrengthUI();
      closeStrengthModal();
    });
  });

  // Accordions
  root.querySelectorAll('.quiz-accordion__item').forEach((item) => {
    const header = item.querySelector('.quiz-accordion__header');
    header.addEventListener('click', () => item.classList.toggle('is-open'));
  });

  // Other treatments modal
  const otherBtn = root.querySelector('[data-result-other]');
  const modal = root.querySelector('.quiz-result-modal');
  const backdrop = modal.querySelector('.quiz-result-modal__backdrop');
  const closeBtns = modal.querySelectorAll('[data-modal-close]');

 function lockBodyScroll() {
  document.documentElement.classList.add('quiz-modal-lock');
  document.body.classList.add('quiz-modal-lock');
}

function unlockBodyScroll() {
  document.documentElement.classList.remove('quiz-modal-lock');
  document.body.classList.remove('quiz-modal-lock');
}

function openModal() {
  modal.classList.add('quiz-result-modal--open');
  modal.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('quiz-modal-lock');
  document.body.classList.add('quiz-modal-lock');
}
function closeModal() {
  modal.classList.remove('quiz-result-modal--open');
  modal.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('quiz-modal-lock');
  document.body.classList.remove('quiz-modal-lock');
}

  if (otherBtn) otherBtn.addEventListener('click', openModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  closeBtns.forEach((b) => b.addEventListener('click', closeModal));

  modal.querySelectorAll('.quiz-result-modal__option').forEach((optEl) => {
    const selectBtn = optEl.querySelector('.quiz-result-modal__select');
    const pid = optEl.getAttribute('data-product-id');
    selectBtn.addEventListener('click', () => {
      closeModal();
      renderTreatmentResult(pid);
    });
  });

  // store selected product
  recordAnswer(`${QUIZ_CATEGORY}.selected_product`, 'Selected treatment product', product.id);

  // Primary CTA logic: out of stock + cart lock + add-to-cart
  const primaryBtn = root.querySelector('[data-result-primary]');
  if (primaryBtn) {
    if (product.status === 'out_of_stock') {
      primaryBtn.disabled = true;
      primaryBtn.classList.add('xo-quiz-button--disabled');
      const span = primaryBtn.querySelector('span');
      if (span) span.textContent = 'Sold out';
      return;
    }

    checkPlanCartLock(primaryBtn);
    attachQuizCartRemoveSync();

primaryBtn.addEventListener('click', async () => {
  const strength = getSelectedStrength();
  if (!strength) {
    alert('Please choose a plan.');
    return;
  }

  // Always check the actual cart items right now
  const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
  const items = Array.isArray(cart?.items) ? cart.items : [];

  const planVariantIds = Array.isArray(PLAN_VARIANT_IDS) ? PLAN_VARIANT_IDS : [];
  const hasPlan = items.some(i => planVariantIds.includes(i.variant_id));

  // Only open cart if a PLAN item is already present
  if (hasPlan) {
    openCartDrawer();
    return;
  }

  // Otherwise add the selected plan
  addPlanToCart(product, strength, primaryBtn);
});
  }
}


function lockPlanButton(btn) {
  if (!btn) return;
  btn.setAttribute('data-locked', 'true');
  btn.classList.add('xo-quiz-button--disabled');
  const span = btn.querySelector('span');
  if (span) span.textContent = 'Only 1 Product Allowed';
}

function unlockPlanButton(btn) {
  if (!btn) return;
  btn.removeAttribute('data-locked');
  btn.classList.remove('xo-quiz-button--disabled');
  const span = btn.querySelector('span');
  if (span) span.textContent = 'Continue with this plan';
}

let QUIZ_CART_REMOVE_LISTENER_ATTACHED = false;

function attachQuizCartRemoveSync() {
  if (QUIZ_CART_REMOVE_LISTENER_ATTACHED) return;
  QUIZ_CART_REMOVE_LISTENER_ATTACHED = true;

  document.addEventListener(
    'click',
    async (event) => {
      // 1. Detect click on remove button
      const removeBtn = event.target.closest('.unicorn_cart_cell_remove');
      if (!removeBtn) return;

      // 2. Wait for Shopify to actually process the removal
      let attempts = 0;
      while (attempts < 20) { // wait up to ~2-4 seconds
        await new Promise(r => setTimeout(r, 200));
        
        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          const items = Array.isArray(cart?.items) ? cart.items : [];
          
          // If cart is empty OR total price is 0 (meaning only free item left), break
          if (cart.item_count === 0 || cart.total_price === 0) {
             break; 
          }
        } catch (e) {}
        attempts++;
      }

      // 3. FORCE REFRESH the drawer HTML
      await refreshCartDrawerHtml().catch(() => {});
const drawer = document.querySelector('cart-drawer-component');
if (drawer && typeof drawer.open === 'function') {
  try { drawer.close?.(); } catch {}
  setTimeout(() => drawer.open(), 50);
}
      // 4. Re-check the "Only 1 Product Allowed" button state
      const quizBtn = document.querySelector('[data-result-primary]');
      if (quizBtn) checkPlanCartLock(quizBtn);
    },
    true
  );
}
async function checkPlanCartLock(btn) {
  if (!btn) return false;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const items = Array.isArray(cart?.items) ? cart.items : [];

    const planVariantIds = Array.isArray(PLAN_VARIANT_IDS) ? PLAN_VARIANT_IDS : [];
    const hasPlan = items.some(i => planVariantIds.includes(i.variant_id));

    if (hasPlan) lockPlanButton(btn);
    else unlockPlanButton(btn);

    return hasPlan;
  } catch (e) {
    unlockPlanButton(btn);
    return false;
  }
}

async function refreshCartDrawerHtml() {
  // Re-fetch the current page HTML (no-store) so Liquid re-renders cart.empty? correctly
  const res = await fetch(window.location.href, {
    credentials: 'same-origin',
    cache: 'no-store'
  });

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const freshDrawer = doc.querySelector('cart-drawer-component');
  const currentDrawer = document.querySelector('cart-drawer-component');

  if (freshDrawer && currentDrawer) {
    currentDrawer.replaceWith(freshDrawer);
  }
}

function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return (window.location.href = '/cart');
  drawer.open();
}
const FREE_CONSULTATION_HANDLE = 'weight-loss-consultation';

let FREE_VARIANT_ID = null;

async function getFreeVariantId() {
  if (FREE_VARIANT_ID) return FREE_VARIANT_ID;

  const res = await fetch(`/products/${FREE_CONSULTATION_HANDLE}.js`);
  if (!res.ok) throw new Error('Free product not found: ' + FREE_CONSULTATION_HANDLE);

  const data = await res.json();
  const variant = data.variants?.find(v => v.available) || data.variants?.[0];
  if (!variant?.id) throw new Error('Free product has no variants');

  FREE_VARIANT_ID = variant.id;
  return FREE_VARIANT_ID;
}

async function addFreeConsultation() {
  try {
    const variantId = await getFreeVariantId();

    // skip if already in cart
    const cart = await fetch('/cart.js').then(r => r.json());
    if (cart.items?.some(i => i.variant_id === variantId)) return;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  } catch (e) {
    console.warn('Free consultation add failed:', e);
  }
}
async function addPlanToCart(product, strength, btn) {
  if (!strength?.variantId) {
    console.error('Missing variantId', { product: product?.id, strength });
    alert('This plan is not fully configured yet (variant missing).');
    return;
  }

  console.log('ADDING PLAN', {
    product: product.id,
    strengthId: strength.id,
    variantId: strength.variantId,
    sellingPlanId: strength.sellingPlanId
  });

  const planVariantIds = Array.isArray(PLAN_VARIANT_IDS) ? PLAN_VARIANT_IDS : [];

  try {
    // 1) Clear any existing PLAN items (but keep free consultation)
    const cartBefore = await fetch('/cart.js').then(r => r.json()).catch(() => null);

    if (cartBefore?.items?.length && planVariantIds.length) {
      const planItems = cartBefore.items.filter(i => planVariantIds.includes(i.variant_id));
      // remove by variant id: quantity 0
      await Promise.all(
        planItems.map(i =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: i.variant_id, quantity: 0 })
          }).then(r => r.text()).catch(() => {})
        )
      );
    }

    // 2) Add selected plan
    const payload = { id: strength.variantId, quantity: 1 };
    if (strength.sellingPlanId) payload.selling_plan = strength.sellingPlanId;

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    const addText = await addRes.text();
    if (!addRes.ok) throw new Error(addText || ('HTTP ' + addRes.status));

    // 3) Ensure free consultation
    await addFreeConsultation();

    // 4) Refresh drawer UI + reopen to force recalculation
    await refreshCartDrawerHtml().catch(() => {});
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      // close/open helps themes that keep stale totals
      try { drawer.close?.(); } catch {}
      setTimeout(() => drawer.open(), 50);
    } else {
      openCartDrawer();
    }

    // 5) Lock button
    lockPlanButton(btn);
  } catch (error) {
    console.error('Add plan error:', error);
    alert(
      'Sorry, we could not add this plan to your cart.\n\n' +
      (error && error.message ? error.message : error)
    );
  }
}

function onQuizComplete() {
  // Decide which product to show
  const using = QUIZ_ANSWERS['weight.using_medication']?.value;
  const which = QUIZ_ANSWERS['weight.which_medication']?.value;

  let selectedId = 'mounjaro'; // default fallback

  if (using === 'yes' && which) {
    selectedId = (which === 'other') ? 'mounjaro' : which;
  }

  // Render results
  renderTreatmentResult(selectedId);

  // Submit in background (don’t block UI)
  submitQuizToAppsScript(selectedId).catch(() => {});
}

  // --- Navigation ---

  function goToNextStep() {
  const steps = getSteps();
  if (currentStepIndex < steps.length - 1) {
    currentStepIndex += 1;
    renderCurrentStep();
    scrollQuizToTop();
  } else {
    onQuizComplete();
    scrollQuizToTop();
  }
}

// Send answers + result to Apps Script, including the selected product
async function submitQuizToAppsScript(selectedProductId) {
  const journey =
    QUIZ_CATEGORY === 'weight' && typeof computeJourneyMetrics === 'function'
      ? computeJourneyMetrics()
      : null;

  // Email from weight.email (or {category}.email fallback if you add others later)
  const emailAnswer =
    QUIZ_ANSWERS['weight.email'] ||
    QUIZ_ANSWERS[`${QUIZ_CATEGORY}.email`] ||
    null;
  const email = emailAnswer && emailAnswer.value ? String(emailAnswer.value) : '';

  const payload = {
    email,
    category: QUIZ_CATEGORY,
    quiz_version: QUIZ_VERSION,
    source_url: window.location.href,
    answers: QUIZ_ANSWERS,
    result: {
      journey,
      selected_product: selectedProductId || null
    }
  };

  try {
    if (QUIZ_ENDPOINT) {
      await fetch(QUIZ_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        mode: 'no-cors',
        keepalive: true
      });
    }
  } catch (e) {
    // Ignore network errors; user can still continue
    // console.error('Quiz submit failed', e);
  }
}
  // --- Init ---
function initQuiz() {
  // DOM references — ADD THESE
  window.root = document.querySelector('[data-quiz-root]');
  window.intro = document.querySelector('[data-quiz-intro]');
  window.backButton = document.querySelector('[data-quiz-back]');
  window.progressText = document.querySelector('[data-quiz-progress-text]');
  window.progressBarFill = document.querySelector('[data-quiz-progress-fill]');

  const steps = getSteps();
  if (!steps.length) {
    if (root) root.innerHTML = '<p>No quiz configured for this category.</p>';
    return;
  }
   
// Disable pinch zoom while on quiz (mobile)
  const vp = document.querySelector('meta[name="viewport"]');
  if (vp) {
    const content = vp.getAttribute('content') || '';
    if (!/user-scalable\s*=\s*no/i.test(content)) {
      vp.setAttribute(
        'content',
        content.replace(/,$/, '') + ', user-scalable=no, maximum-scale=1'
      );
    }
  }
  document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
  document.addEventListener('gesturechange', (e) => e.preventDefault(), { passive: false });
  document.addEventListener('gestureend', (e) => e.preventDefault(), { passive: false });
  document.addEventListener('wheel', (e) => { if (e.ctrlKey) e.preventDefault(); }, { passive: false });
  // Start with intro visible, quiz root hidden
  if (root) root.style.display = 'none';
  if (intro) intro.style.display = '';

  // Progress on intro: 4% as in client design
  if (progressText) progressText.textContent = '4%';
  if (progressBarFill) progressBarFill.style.width = '4%';

const introButton = document.querySelector('[data-quiz-intro-continue]');
if (introButton) {
  introButton.addEventListener('click', (e) => {
    e.preventDefault();
    recordAnswer(QUIZ_CATEGORY + '.intro', 'Intro consent', 'continue');
    if (intro) intro.style.display = 'none';
    if (root) root.style.display = '';
    currentStepIndex = 0;
    renderCurrentStep();
    scrollQuizToTop();
  });
}

  // Back arrow behaviour
 if (backButton) {
  backButton.addEventListener('click', () => {
    if (root && root.style.display === 'none') {
      window.history.back();
      return;
    }

    const steps = getSteps();
    const step = steps[currentStepIndex];

    // safety sub-step branch
    if (
      step &&
      step.id === 'weight.current_situation' &&
      CURRENT_SITUATION_MODE === 'safety'
    ) {
      CURRENT_SITUATION_MODE = 'options';
      updateProgress();
      renderCurrentStep();
      scrollQuizToTop();
      return;
    }

    if (step && step.id === 'weight.gp_details' && GP_DETAILS_MODE === 'manual') {
  GP_DETAILS_MODE = 'search';
  renderCurrentStep();
  updateProgress();
  scrollQuizToTop();
  return;
}
    // 👇 we’ll replace the "go to previous step" part here
   if (currentStepIndex > 0) {
  let targetIndex = currentStepIndex - 1;
  const steps = getSteps();

  const sexAnswer = QUIZ_ANSWERS['weight.sex_at_birth'];
  const sexVal = sexAnswer && sexAnswer.value;

  const usingAnswer = QUIZ_ANSWERS['weight.using_medication'];
  const usingVal = usingAnswer && usingAnswer.value;

  // Walk backwards, skipping steps that should be hidden
  while (targetIndex > 0) {
    const candidate = steps[targetIndex];

    // Skip current_situation if Male
    if (candidate.id === 'weight.current_situation' && sexVal === 'male') {
      targetIndex -= 1;
      continue;
    }

    // Skip which_medication if user answered "no" to using_medication
    if (candidate.id === 'weight.which_medication' && usingVal === 'no') {
      targetIndex -= 1;
      continue;
    }

    break;
  }

  if (targetIndex < 0) targetIndex = 0;

  currentStepIndex = targetIndex;
  renderCurrentStep();
  scrollQuizToTop();
  return;
}

    // back to intro...
    if (intro) intro.style.display = '';
    if (root) root.style.display = 'none';
    if (progressText) progressText.textContent = '4%';
    if (progressBarFill) progressBarFill.style.width = '4%';
  });
}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuiz);
} else {
  initQuiz();
}
})();